import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import Slider from "react-slick";
import bannerextraimgleft from "../images/banner-extra-img-left.png";
import bannerextraimgright from "../images/banner-extra-img-right.png";
import bannerthemeimg1 from "../images/banner-img-wrp-img-1.png";
import bannerthemeimg2 from "../images/banner-img-wrp-img-2.png";
import bannerthemeimg3 from "../images/banner-img-wrp-img-3.png";
import bannerthemeimg4 from "../images/banner-img-wrp-img-4.png";
import bannerthemeimg5 from "../images/banner-img-wrp-img-5.png";
import bannerthemeimg6 from "../images/banner-img-wrp-img-6.png";
import weprovideimg from "../images/we_provide_img.png";
import buildwebsiteimg from "../images/build_website_img.png";
import buildappimg from "../images/build-app-img.png";
import profileimg from "../images/profile-img.png";
import websitetempletsimg1 from "../images/website-templets-img-1.png";
import websitetempletsimg2 from "../images/website-templets-img-2.png";
import ourproejctsimg1 from "../images/our-proejcts-img1.png";
import ourproejctsimg2 from "../images/our-proejcts-img2.png";
import ourproejctsimg3 from "../images/our-proejcts-img3.png";
import ourproejctsimg4 from "../images/our-proejcts-img4.png";
import ourproejctsimg5 from "../images/our-proejcts-img5.png";
import ourproejctsimg6 from "../images/our-proejcts-img6.png";
// import insightsimg1 from "../images/insights-img-1.png";
// import insightsimg2 from "../images/insights-img-2.png";
// import insightsimg3 from "../images/insights-img-3.png";
// import websitestepimg1 from "../images/website-setp-img-1.png";

import jewellerystoreimg from "../images/jewellery-store.jpg";
import kishoricreationimg from "../images/kishoricreation.jpg";
import interiordesigningimg from "../images/interiordesigning.jpg";
import laxmirajdryfruitsimg from "../images/laxmirajdryfruits.jpg";
import unibestimg from "../images/unibest.jpg";
import yashindustriesimg from "../images/yashindustries.jpg";

import { MdOutlineArrowOutward } from "react-icons/md";

import LocationSlider from "./LocationSlider";
import { WebsiteStep } from "./component/WebsiteStep";
import { BrandSlider } from "./component/BrandSlider";
import reachCustomeMain from "../images/reachcustomermainnew.png";
import reachCustomeMain2 from "../images/reachcustomermain2.png";
import reachCustomeMain3 from "../images/reachcustomermain3.png";
import reachCustomeMain4 from "../images/reportsnewimage.png";
import intelligentappsimg1 from "../images/lesdesktopapp.gif";
import intelligentappsimg2 from "../images/intelligentappmobilenew2.gif";
import accountingtabimg from "../images/accountingtabimg.png";
import accountingtabextraimg from "../images/accountingtabextraimg.png";
import dashbordtabsimg from "../images/dashboardtabsimg.png";
import inventroytabsimg from "../images/inventorytabsimg.png";
import invoicetabsimg from "../images/invoiceimage.png";
import salestabsimg from "../images/salestabsimg.png";
import producttabsimg from "../images/productimagenew.png";
import { BiPlus } from "react-icons/bi";

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <!-- ===Banner-Start=== --> */}
      <section className="banner_section">
        <img
          src={bannerextraimgleft}
          alt=""
          className="banner-extra-img-left"
        />
        <img
          src={bannerextraimgright}
          alt=""
          className="banner-extra-img-right"
        />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="banner_main_wrp">
                <div className="banner_content">
                  <h1>
                    <span>LaunchEstore</span> <br /> Start Selling Online in 30
                    Seconds!
                  </h1>
                  <h4>
                    Instantly launch your online store and start selling. Fast
                    setup, powerful tools, and everything you need to grow your
                    business.
                  </h4>
                  <div className="banner_btn">
                    <button
                      className="cmn-btn"
                      onClick={() =>
                        (window.location.href =
                          "https://register.launchestore.com")
                      }
                    >
                      <span className="cmn-btn-text1">
                        Create Your Store{" "}
                        <MdOutlineArrowOutward className="button-icon" />
                      </span>

                      <span className="cmn-btn-text2">
                        Create Your Store{" "}
                        <MdOutlineArrowOutward className="button-icon" />
                      </span>
                    </button>
                    <button
                      className="cmn-btn play-reel-btn"
                      onClick={() => {
                        navigate("/contact");
                      }}
                    >
                      <span className="cmn-btn-text1">Book a Free Demo</span>
                      <span className="cmn-btn-text2">Book a Free Demo</span>
                    </button>
                  </div>
                  <p>
                    Launch your <span>e-commerce</span> store today
                  </p>
                </div>

                <div className="banner-image-wrp">
                  <img
                    src={bannerthemeimg1}
                    alt=""
                    className="banner-img-wrp-img-1"
                  />
                  <img
                    src={bannerthemeimg2}
                    alt=""
                    className="banner-img-wrp-img-2"
                  />
                  <img
                    src={bannerthemeimg3}
                    alt=""
                    className="banner-img-wrp-img-3"
                  />
                  <img
                    src={bannerthemeimg4}
                    alt=""
                    className="banner-img-wrp-img-4"
                  />
                  <img
                    src={bannerthemeimg5}
                    alt=""
                    className="banner-img-wrp-img-5"
                  />
                  <img
                    src={bannerthemeimg6}
                    alt=""
                    className="banner-img-wrp-img-6"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          {/* <div className="banner-brand-slider">
            <div className="owl-carousel owl-theme brand-slider">
              <Slider {...settings}>
                <div className="banner-brand-slider-img">
                  <img src={brandimg1} alt="brand-img" />
                </div>
                <div className="banner-brand-slider-img">
                  <img src={brandimg2} alt="brand-img" />
                </div>
                <div className="banner-brand-slider-img">
                  <img src={brandimg3} alt="brand-img" />
                </div>
                <div className="banner-brand-slider-img">
                  <img src={brandimg4} alt="brand-img" />
                </div>
                <div className="banner-brand-slider-img">
                  <img src={brandimg5} alt="brand-img" />
                </div>
                <div className="banner-brand-slider-img">
                  <img src={brandimg6} alt="brand-img" />
                </div>
                <div className="banner-brand-slider-img">
                  <img src={brandimg7} alt="brand-img" />
                </div>
              </Slider>
            </div>
          </div> */}
          <BrandSlider />
        </div>
      </section>
      {/* <!-- ===Banner-end=== --> */}

      {/* <!-- ===Content-Start=== --> */}
      <section className="Content_section p-100">
        <div className="container">
          <div className="Content_wrapper">
            <h2>
              Launch your online store on the best eCommerce platform. With
              powerful features and seamless integration, easily grow your
              business and start selling today!
            </h2>
          </div>
        </div>
      </section>
      {/* <!-- ===Content-end=== --> */}

      {/* ===system-info-start=== */}
      <section className="system_info p-100 pb-0">
        <div className="system_info_tabs">
          <div className="container">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-accounting-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-accounting"
                  type="button"
                  role="tab"
                >
                  <span>
                    <svg
                      width="29"
                      height="30"
                      viewBox="0 0 29 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M28.6309 26.6227L26.0681 10.3416C25.8269 8.89435 24.5907 7.80894 23.1134 7.83909H22.3596C22.2692 3.49744 18.6813 0 14.3396 0C12.199 0 10.1789 0.844206 8.67137 2.35172C7.16385 3.85924 6.31964 5.87932 6.31964 7.98984H5.77694C4.35987 7.98984 3.12371 9.04509 2.8825 10.432L0.0483719 26.5323C-0.283282 28.3413 1.13378 29.9996 2.97295 29.9996H25.6762C27.5153 30.0297 28.9022 28.4016 28.6309 26.6227ZM8.15881 7.98984C8.18896 4.613 10.9628 1.83916 14.3396 1.83916C17.6863 1.83916 20.43 4.52255 20.5205 7.83909L8.15881 7.98984Z"
                        fill="white"
                      />
                      <path
                        d="M5.65049 19.2649C5.52988 19.5061 5.56003 19.8077 5.74094 20.0187C5.92184 20.2298 6.19319 20.3202 6.46455 20.2599C7.24845 20.079 8.24342 19.9886 9.14793 20.3805C9.87153 18.5112 10.6856 17.0338 11.4394 15.9183C10.0826 15.6771 7.30875 15.7374 5.65049 19.2649Z"
                        fill="black"
                      />
                      <path
                        d="M17.2569 21.9183C16.1112 22.6419 14.6037 23.3956 12.7344 24.0891C13.0962 24.9936 13.0057 25.9886 12.7947 26.7725C12.7344 27.0438 12.8248 27.3152 13.0057 27.4961C13.2168 27.677 13.4881 27.7071 13.7595 27.6167C17.3474 26.0187 17.4378 23.2449 17.2569 21.9183Z"
                        fill="black"
                      />
                      <path
                        d="M8.43761 21.6343L7.48828 22.561L10.5631 25.711L11.5124 24.7844L8.43761 21.6343Z"
                        fill="black"
                      />
                      <path
                        d="M19.6132 19.1758C19.6132 19.1758 17.0806 21.9195 11.6836 23.6683L10.6284 22.5828L10.5982 22.5527L9.54297 21.4673C11.4424 16.1005 14.2163 13.6282 14.2163 13.6282C17.0806 10.794 20.4875 10.4322 22.0554 10.4021C22.2966 10.4021 22.5378 10.4925 22.6885 10.6734C22.8694 10.8543 22.9599 11.0654 22.9599 11.3066C22.9297 12.9347 22.5378 16.402 19.6132 19.1758Z"
                        fill="black"
                      />
                      <path
                        d="M5.02047 26.5316C4.96017 26.5316 4.93002 26.5014 4.89987 26.4713C4.80942 26.3808 4.80942 26.2301 4.89987 26.1698L6.55814 24.602C6.64859 24.5115 6.79934 24.5115 6.85964 24.602C6.95009 24.6924 6.95009 24.8432 6.85964 24.9035L5.20137 26.4713C5.17122 26.5014 5.08077 26.5316 5.02047 26.5316Z"
                        fill="black"
                      />
                      <path
                        d="M6.43844 28.0082C6.37814 28.0082 6.34799 27.9781 6.31784 27.9479C6.22739 27.8575 6.22739 27.7067 6.31784 27.6464L7.85551 26.1992C7.94596 26.1087 8.09671 26.1087 8.15701 26.1992C8.24746 26.2896 8.24746 26.4404 8.15701 26.5007L6.61934 27.9479C6.55904 27.9781 6.49874 28.0082 6.43844 28.0082Z"
                        fill="black"
                      />
                      <path
                        d="M6.55953 26.4713C6.49923 26.4713 6.46908 26.4412 6.43893 26.411C6.34848 26.3206 6.34848 26.1698 6.43893 26.1095L8.24795 24.4211C8.3384 24.3307 8.48916 24.3307 8.54946 24.4211C8.63991 24.5116 8.63991 24.6623 8.54946 24.7226L6.74044 26.411C6.68013 26.4713 6.61983 26.4713 6.55953 26.4713Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  Accounting Application
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-dashboard-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-dashboard"
                  type="button"
                  role="tab"
                >
                  <span>
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V8C0 8.53043 0.210714 9.03914 0.585786 9.41421C0.960859 9.78929 1.46957 10 2 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V2C10 1.46957 9.78929 0.960859 9.41421 0.585786C9.03914 0.210714 8.53043 0 8 0ZM8 8H2V2H8V8ZM20 0H14C13.4696 0 12.9609 0.210714 12.5858 0.585786C12.2107 0.960859 12 1.46957 12 2V8C12 8.53043 12.2107 9.03914 12.5858 9.41421C12.9609 9.78929 13.4696 10 14 10H20C20.5304 10 21.0391 9.78929 21.4142 9.41421C21.7893 9.03914 22 8.53043 22 8V2C22 1.46957 21.7893 0.960859 21.4142 0.585786C21.0391 0.210714 20.5304 0 20 0ZM20 8H14V2H20V8ZM8 12H2C1.46957 12 0.960859 12.2107 0.585786 12.5858C0.210714 12.9609 0 13.4696 0 14V20C0 20.5304 0.210714 21.0391 0.585786 21.4142C0.960859 21.7893 1.46957 22 2 22H8C8.53043 22 9.03914 21.7893 9.41421 21.4142C9.78929 21.0391 10 20.5304 10 20V14C10 13.4696 9.78929 12.9609 9.41421 12.5858C9.03914 12.2107 8.53043 12 8 12ZM8 20H2V14H8V20ZM20 12H14C13.4696 12 12.9609 12.2107 12.5858 12.5858C12.2107 12.9609 12 13.4696 12 14V20C12 20.5304 12.2107 21.0391 12.5858 21.4142C12.9609 21.7893 13.4696 22 14 22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V14C22 13.4696 21.7893 12.9609 21.4142 12.5858C21.0391 12.2107 20.5304 12 20 12ZM20 20H14V14H20V20Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Dashboard
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-inventory-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-inventory"
                  type="button"
                  role="tab"
                >
                  <span>
                    <svg
                      width="26"
                      height="24"
                      viewBox="0 0 26 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M26 8C26.0005 7.90702 25.9879 7.81444 25.9625 7.725L24.1688 1.45C24.0482 1.03364 23.7962 0.667454 23.4504 0.406117C23.1045 0.14478 22.6835 0.00231617 22.25 0H3.75C3.31655 0.00231617 2.89547 0.14478 2.54965 0.406117C2.20382 0.667454 1.95182 1.03364 1.83125 1.45L0.0387507 7.725C0.012928 7.81438 -0.000117927 7.90696 8.03149e-07 8V10C8.03149e-07 10.7762 0.180726 11.5418 0.527865 12.2361C0.875003 12.9303 1.37902 13.5343 2 14V23C2 23.2652 2.10536 23.5196 2.29289 23.7071C2.48043 23.8946 2.73478 24 3 24H23C23.2652 24 23.5196 23.8946 23.7071 23.7071C23.8946 23.5196 24 23.2652 24 23V14C24.621 13.5343 25.125 12.9303 25.4721 12.2361C25.8193 11.5418 26 10.7762 26 10V8ZM3.75 2H22.25L23.6775 7H2.32625L3.75 2ZM10 9H16V10C16 10.7956 15.6839 11.5587 15.1213 12.1213C14.5587 12.6839 13.7957 13 13 13C12.2044 13 11.4413 12.6839 10.8787 12.1213C10.3161 11.5587 10 10.7956 10 10V9ZM8 9V10C7.99982 10.5159 7.86661 11.023 7.61324 11.4724C7.35987 11.9217 6.9949 12.2982 6.55358 12.5653C6.11226 12.8325 5.60951 12.9813 5.09388 12.9975C4.57825 13.0136 4.06717 12.8965 3.61 12.6575C3.54044 12.6034 3.46392 12.5588 3.3825 12.525C2.95885 12.2538 2.61019 11.8804 2.36861 11.4392C2.12702 10.9979 2.00027 10.503 2 10V9H8ZM22 22H4V14.9C4.3292 14.9664 4.66418 14.9999 5 15C5.77623 15 6.54179 14.8193 7.23607 14.4721C7.93035 14.125 8.53427 13.621 9 13C9.46574 13.621 10.0697 14.125 10.7639 14.4721C11.4582 14.8193 12.2238 15 13 15C13.7762 15 14.5418 14.8193 15.2361 14.4721C15.9303 14.125 16.5343 13.621 17 13C17.4657 13.621 18.0697 14.125 18.7639 14.4721C19.4582 14.8193 20.2238 15 21 15C21.3358 14.9999 21.6708 14.9664 22 14.9V22ZM22.6163 12.525C22.5359 12.5589 22.4603 12.603 22.3913 12.6562C21.9341 12.8955 21.423 13.0129 20.9073 12.9969C20.3916 12.981 19.8888 12.8323 19.4473 12.5653C19.0058 12.2982 18.6407 11.9218 18.3872 11.4725C18.1336 11.0231 18.0003 10.516 18 10V9H24V10C23.9996 10.5032 23.8727 10.9981 23.6308 11.4394C23.389 11.8806 23.0401 12.2539 22.6163 12.525Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Inventory Management
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-invoice-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-invoice"
                  type="button"
                  role="tab"
                >
                  <span>
                    <svg
                      width="27"
                      height="21"
                      viewBox="0 0 27 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.5 11C1.23478 11 0.98043 10.8946 0.792893 10.7071C0.605357 10.5196 0.5 10.2652 0.5 10C0.5 9.73478 0.605357 9.48043 0.792893 9.29289C0.98043 9.10536 1.23478 9 1.5 9H5C5.26522 9 5.51957 8.89464 5.70711 8.70711C5.89464 8.51957 6 8.26522 6 8C6 7.73478 5.89464 7.48043 5.70711 7.29289C5.51957 7.10536 5.26522 7 5 7H3C2.20435 7 1.44129 6.68393 0.87868 6.12132C0.316071 5.55871 0 4.79565 0 4C0 3.20435 0.316071 2.44129 0.87868 1.87868C1.44129 1.31607 2.20435 1 3 1C3 0.734784 3.10536 0.48043 3.29289 0.292893C3.48043 0.105357 3.73478 0 4 0C4.26522 0 4.51957 0.105357 4.70711 0.292893C4.89464 0.48043 5 0.734784 5 1H6C6.26522 1 6.51957 1.10536 6.70711 1.29289C6.89464 1.48043 7 1.73478 7 2C7 2.26522 6.89464 2.51957 6.70711 2.70711C6.51957 2.89464 6.26522 3 6 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4C2 4.26522 2.10536 4.51957 2.29289 4.70711C2.48043 4.89464 2.73478 5 3 5H5C5.79565 5 6.55871 5.31607 7.12132 5.87868C7.68393 6.44129 8 7.20435 8 8C8 8.79565 7.68393 9.55871 7.12132 10.1213C6.55871 10.6839 5.79565 11 5 11C5 11.2652 4.89464 11.5196 4.70711 11.7071C4.51957 11.8946 4.26522 12 4 12C3.73478 12 3.48043 11.8946 3.29289 11.7071C3.10536 11.5196 3 11.2652 3 11H1.5ZM27 2V19C27 19.5304 26.7893 20.0391 26.4142 20.4142C26.0391 20.7893 25.5304 21 25 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V14C1 13.7348 1.10536 13.4804 1.29289 13.2929C1.48043 13.1054 1.73478 13 2 13C2.26522 13 2.51957 13.1054 2.70711 13.2929C2.89464 13.4804 3 13.7348 3 14V19H18V15H8C7.73478 15 7.48043 14.8946 7.29289 14.7071C7.10536 14.5196 7 14.2652 7 14C7 13.7348 7.10536 13.4804 7.29289 13.2929C7.48043 13.1054 7.73478 13 8 13H18V9H11C10.7348 9 10.4804 8.89464 10.2929 8.70711C10.1054 8.51957 10 8.26522 10 8C10 7.73478 10.1054 7.48043 10.2929 7.29289C10.4804 7.10536 10.7348 7 11 7H25V3H10C9.73478 3 9.48043 2.89464 9.29289 2.70711C9.10536 2.51957 9 2.26522 9 2C9 1.73478 9.10536 1.48043 9.29289 1.29289C9.48043 1.10536 9.73478 1 10 1H26C26.2652 1 26.5196 1.10536 26.7071 1.29289C26.8946 1.48043 27 1.73478 27 2ZM20 13H25V9H20V13ZM25 19V15H20V19H25Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Invoice Management
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-sales-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-sales"
                  type="button"
                  role="tab"
                >
                  <span>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M26.2325 10.8525C25.7612 10.36 25.2738 9.8525 25.09 9.40625C24.92 8.9975 24.91 8.32 24.9 7.66375C24.8813 6.44375 24.8612 5.06125 23.9 4.1C22.9387 3.13875 21.5562 3.11875 20.3363 3.1C19.68 3.09 19.0025 3.08 18.5938 2.91C18.1488 2.72625 17.64 2.23875 17.1475 1.7675C16.285 0.93875 15.305 0 14 0C12.695 0 11.7162 0.93875 10.8525 1.7675C10.36 2.23875 9.8525 2.72625 9.40625 2.91C9 3.08 8.32 3.09 7.66375 3.1C6.44375 3.11875 5.06125 3.13875 4.1 4.1C3.13875 5.06125 3.125 6.44375 3.1 7.66375C3.09 8.32 3.08 8.9975 2.91 9.40625C2.72625 9.85125 2.23875 10.36 1.7675 10.8525C0.93875 11.7162 0 12.695 0 14C0 15.305 0.93875 16.2837 1.7675 17.1475C2.23875 17.64 2.72625 18.1475 2.91 18.5938C3.08 19.0025 3.09 19.68 3.1 20.3363C3.11875 21.5562 3.13875 22.9387 4.1 23.9C5.06125 24.8612 6.44375 24.8813 7.66375 24.9C8.32 24.91 8.9975 24.92 9.40625 25.09C9.85125 25.2738 10.36 25.7612 10.8525 26.2325C11.715 27.0613 12.695 28 14 28C15.305 28 16.2837 27.0613 17.1475 26.2325C17.64 25.7612 18.1475 25.2738 18.5938 25.09C19.0025 24.92 19.68 24.91 20.3363 24.9C21.5562 24.8813 22.9387 24.8612 23.9 23.9C24.8612 22.9387 24.8813 21.5562 24.9 20.3363C24.91 19.68 24.92 19.0025 25.09 18.5938C25.2738 18.1488 25.7612 17.64 26.2325 17.1475C27.0613 16.2837 28 15.305 28 14C28 12.695 27.0613 11.7162 26.2325 10.8525ZM24.7887 15.7638C24.19 16.3888 23.57 17.035 23.2412 17.8288C22.9262 18.5913 22.9125 19.4625 22.9 20.3062C22.8875 21.1812 22.8738 22.0975 22.485 22.485C22.0963 22.8725 21.1862 22.8875 20.3062 22.9C19.4625 22.9125 18.5913 22.9262 17.8288 23.2412C17.035 23.57 16.3888 24.19 15.7638 24.7887C15.1388 25.3875 14.5 26 14 26C13.5 26 12.8562 25.385 12.2362 24.7887C11.6163 24.1925 10.965 23.57 10.1713 23.2412C9.40875 22.9262 8.5375 22.9125 7.69375 22.9C6.81875 22.8875 5.9025 22.8738 5.515 22.485C5.1275 22.0963 5.1125 21.1862 5.1 20.3062C5.0875 19.4625 5.07375 18.5913 4.75875 17.8288C4.43 17.035 3.81 16.3888 3.21125 15.7638C2.6125 15.1388 2 14.5 2 14C2 13.5 2.615 12.8575 3.21125 12.2362C3.8075 11.615 4.43 10.965 4.75875 10.1713C5.07375 9.40875 5.0875 8.5375 5.1 7.69375C5.1125 6.81875 5.12625 5.9025 5.515 5.515C5.90375 5.1275 6.81375 5.1125 7.69375 5.1C8.5375 5.0875 9.40875 5.07375 10.1713 4.75875C10.965 4.43 11.6112 3.81 12.2362 3.21125C12.8612 2.6125 13.5 2 14 2C14.5 2 15.1438 2.615 15.7638 3.21125C16.3838 3.8075 17.035 4.43 17.8288 4.75875C18.5913 5.07375 19.4625 5.0875 20.3062 5.1C21.1812 5.1125 22.0975 5.12625 22.485 5.515C22.8725 5.90375 22.8875 6.81375 22.9 7.69375C22.9125 8.5375 22.9262 9.40875 23.2412 10.1713C23.57 10.965 24.19 11.6112 24.7887 12.2362C25.3875 12.8612 26 13.5 26 14C26 14.5 25.385 15.1425 24.7887 15.7638ZM13 10C13 9.40666 12.8241 8.82664 12.4944 8.33329C12.1648 7.83994 11.6962 7.45542 11.1481 7.22836C10.5999 7.0013 9.99667 6.94189 9.41473 7.05764C8.83279 7.1734 8.29824 7.45912 7.87868 7.87868C7.45912 8.29824 7.1734 8.83279 7.05764 9.41473C6.94189 9.99667 7.0013 10.5999 7.22836 11.1481C7.45542 11.6962 7.83994 12.1648 8.33329 12.4944C8.82664 12.8241 9.40666 13 10 13C10.7956 13 11.5587 12.6839 12.1213 12.1213C12.6839 11.5587 13 10.7956 13 10ZM9 10C9 9.80222 9.05865 9.60888 9.16853 9.44443C9.27841 9.27998 9.43459 9.15181 9.61732 9.07612C9.80004 9.00043 10.0011 8.98063 10.1951 9.01921C10.3891 9.0578 10.5673 9.15304 10.7071 9.29289C10.847 9.43275 10.9422 9.61093 10.9808 9.80491C11.0194 9.99889 10.9996 10.2 10.9239 10.3827C10.8482 10.5654 10.72 10.7216 10.5556 10.8315C10.3911 10.9414 10.1978 11 10 11C9.73478 11 9.48043 10.8946 9.29289 10.7071C9.10536 10.5196 9 10.2652 9 10ZM18 15C17.4067 15 16.8266 15.1759 16.3333 15.5056C15.8399 15.8352 15.4554 16.3038 15.2284 16.8519C15.0013 17.4001 14.9419 18.0033 15.0576 18.5853C15.1734 19.1672 15.4591 19.7018 15.8787 20.1213C16.2982 20.5409 16.8328 20.8266 17.4147 20.9424C17.9967 21.0581 18.5999 20.9987 19.1481 20.7716C19.6962 20.5446 20.1648 20.1601 20.4944 19.6667C20.8241 19.1734 21 18.5933 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15ZM18 19C17.8022 19 17.6089 18.9414 17.4444 18.8315C17.28 18.7216 17.1518 18.5654 17.0761 18.3827C17.0004 18.2 16.9806 17.9989 17.0192 17.8049C17.0578 17.6109 17.153 17.4327 17.2929 17.2929C17.4327 17.153 17.6109 17.0578 17.8049 17.0192C17.9989 16.9806 18.2 17.0004 18.3827 17.0761C18.5654 17.1518 18.7216 17.28 18.8315 17.4444C18.9414 17.6089 19 17.8022 19 18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19ZM19.7075 9.7075L9.7075 19.7075C9.61459 19.8004 9.50429 19.8741 9.3829 19.9244C9.2615 19.9747 9.1314 20.0006 9 20.0006C8.8686 20.0006 8.7385 19.9747 8.6171 19.9244C8.49571 19.8741 8.38541 19.8004 8.2925 19.7075C8.19959 19.6146 8.12589 19.5043 8.07561 19.3829C8.02532 19.2615 7.99944 19.1314 7.99944 19C7.99944 18.8686 8.02532 18.7385 8.07561 18.6171C8.12589 18.4957 8.19959 18.3854 8.2925 18.2925L18.2925 8.2925C18.3854 8.19959 18.4957 8.12589 18.6171 8.07561C18.7385 8.02532 18.8686 7.99944 19 7.99944C19.1314 7.99944 19.2615 8.02532 19.3829 8.07561C19.5043 8.12589 19.6146 8.19959 19.7075 8.2925C19.8004 8.38541 19.8741 8.49571 19.9244 8.6171C19.9747 8.7385 20.0006 8.8686 20.0006 9C20.0006 9.1314 19.9747 9.2615 19.9244 9.3829C19.8741 9.50429 19.8004 9.61459 19.7075 9.7075Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Sales & Purchase
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-product-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-product"
                  type="button"
                  role="tab"
                >
                  <span>
                    <svg
                      width="26"
                      height="28"
                      viewBox="0 0 26 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.96 6.26877L13.96 0.250022C13.6661 0.0876253 13.3358 0.00244141 13 0.00244141C12.6642 0.00244141 12.3339 0.0876253 12.04 0.250022L1.04 6.27127C0.725861 6.44315 0.463629 6.69622 0.28069 7.00405C0.0977502 7.31188 0.000812822 7.66319 0 8.02127V19.9763C0.000812822 20.3344 0.0977502 20.6857 0.28069 20.9935C0.463629 21.3013 0.725861 21.5544 1.04 21.7263L12.04 27.7475C12.3339 27.9099 12.6642 27.9951 13 27.9951C13.3358 27.9951 13.6661 27.9099 13.96 27.7475L24.96 21.7263C25.2741 21.5544 25.5364 21.3013 25.7193 20.9935C25.9023 20.6857 25.9992 20.3344 26 19.9763V8.02252C25.9999 7.6638 25.9032 7.31172 25.7203 7.00317C25.5373 6.69462 25.2747 6.44096 24.96 6.26877ZM13 2.00002L23.0425 7.50002L19.3213 9.53752L9.2775 4.03752L13 2.00002ZM13 13L2.9575 7.50002L7.195 5.18002L17.2375 10.68L13 13ZM2 9.25002L12 14.7225V25.4463L2 19.9775V9.25002ZM24 19.9725L14 25.4463V14.7275L18 12.5388V17C18 17.2652 18.1054 17.5196 18.2929 17.7071C18.4804 17.8947 18.7348 18 19 18C19.2652 18 19.5196 17.8947 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17V11.4438L24 9.25002V19.9713V19.9725Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Product Management
                </button>
              </li>
            </ul>
          </div>

          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-accounting"
              role="tabpanel"
              aria-labelledby="pills-accounting-tab"
            >
              <div className="system_info_tabs_main container">
                <div className="row">
                  <div className="col-lg-6 align-self-center">
                    <div className="system_info_tabs_content">
                      <div className="build_web_app-content-wrp">
                        <span className="system_info_tabs_content_tags">
                          Accounting App
                        </span>
                        <h3>Smart daily business accounting</h3>
                        <p>
                          Track your daily accounting with real-time entries
                          from sales, purchases, payments, and expenses directly
                          within the app.
                        </p>
                        <ul>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1066)">
                                  <path
                                    d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1066">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.355469)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Sales & Purchase Entries</strong> */}
                            – Auto-record transactions from invoices and orders
                            into your accounting.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1071)">
                                  <path
                                    d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1071">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.544678)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong> Payments In & Out</strong> */}
                            – Log customer payments and supplier expenses
                            directly to balance accounts.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1077)">
                                  <path
                                    d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1077">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.724609)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Expense Tracking</strong>  */}
                            – Add and categorize business expenses for accurate
                            financial oversight.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Real-Time Profit View</strong> */}
                            – View daily income, expense, and profit summaries
                            instantly.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Comprehensive Reports</strong>  */}
                            – Access detailed financial reports and statements
                            anytime.
                          </li>
                        </ul>
                        <button
                          className="cmn-btn"
                          onClick={() =>
                            (window.location.href =
                              "https://register.launchestore.com")
                          }
                        >
                          <span className="cmn-btn-text1">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                          <span className="cmn-btn-text2">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                        </button>

                        <div className="build_web_app-content-profile d-none">
                          <p>
                            “LaunchEstore transformed my online business!
                            Setting up my store was so simple, and their
                            customer support is always there to help. Thanks to
                            their tools, I reached new customers and saw sales
                            skyrocket. Highly recommended!”
                          </p>
                          <div className="build_web_app-profile-inner d-none">
                            <div className="build_web_app-profile-img">
                              <img src={profileimg} alt="" />
                            </div>
                            <div className="build_web_app-profile-content">
                              <h4>Priya Mehta</h4>
                              <p>Jwellery Owner</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="system_info_tabs_img">
                      <img src={accountingtabimg} alt={accountingtabimg} />
                      <img
                        src={accountingtabextraimg}
                        alt={accountingtabextraimg}
                        className="accounting-tab-extra-img"
                      />
                      <div className="system_info_tabs_img_icon1">
                        <svg
                          width="56"
                          height="66"
                          viewBox="0 0 56 66"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M54.7688 18.7313L37.2688 1.23125C37.0364 0.999165 36.7606 0.81513 36.4571 0.68966C36.1536 0.56419 35.8284 0.499743 35.5 0.500001H5.5C4.17392 0.500001 2.90215 1.02678 1.96447 1.96447C1.02678 2.90215 0.5 4.17392 0.5 5.5V60.5C0.5 61.8261 1.02678 63.0979 1.96447 64.0355C2.90215 64.9732 4.17392 65.5 5.5 65.5H50.5C51.8261 65.5 53.0979 64.9732 54.0355 64.0355C54.9732 63.0979 55.5 61.8261 55.5 60.5V20.5C55.5003 20.1716 55.4358 19.8464 55.3103 19.5429C55.1849 19.2394 55.0008 18.9636 54.7688 18.7313ZM38 48H18C17.337 48 16.7011 47.7366 16.2322 47.2678C15.7634 46.7989 15.5 46.163 15.5 45.5C15.5 44.837 15.7634 44.2011 16.2322 43.7322C16.7011 43.2634 17.337 43 18 43H38C38.663 43 39.2989 43.2634 39.7678 43.7322C40.2366 44.2011 40.5 44.837 40.5 45.5C40.5 46.163 40.2366 46.7989 39.7678 47.2678C39.2989 47.7366 38.663 48 38 48ZM38 38H18C17.337 38 16.7011 37.7366 16.2322 37.2678C15.7634 36.7989 15.5 36.163 15.5 35.5C15.5 34.837 15.7634 34.2011 16.2322 33.7322C16.7011 33.2634 17.337 33 18 33H38C38.663 33 39.2989 33.2634 39.7678 33.7322C40.2366 34.2011 40.5 34.837 40.5 35.5C40.5 36.163 40.2366 36.7989 39.7678 37.2678C39.2989 37.7366 38.663 38 38 38ZM35.5 20.5V6.75L49.25 20.5H35.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="system_info_tabs_img_icon2">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.875 4.875V17.625C21.875 18.7522 21.4272 19.8332 20.6302 20.6302C19.8332 21.4272 18.7522 21.875 17.625 21.875H4.875C3.74783 21.875 2.66683 21.4272 1.8698 20.6302C1.07277 19.8332 0.625 18.7522 0.625 17.625V4.875C0.625 3.74783 1.07277 2.66683 1.8698 1.8698C2.66683 1.07277 3.74783 0.625 4.875 0.625H17.625C18.7522 0.625 19.8332 1.07277 20.6302 1.8698C21.4272 2.66683 21.875 3.74783 21.875 4.875ZM43.125 0.625H30.375C29.2478 0.625 28.1668 1.07277 27.3698 1.8698C26.5728 2.66683 26.125 3.74783 26.125 4.875V17.625C26.125 18.7522 26.5728 19.8332 27.3698 20.6302C28.1668 21.4272 29.2478 21.875 30.375 21.875H43.125C44.2522 21.875 45.3332 21.4272 46.1302 20.6302C46.9272 19.8332 47.375 18.7522 47.375 17.625V4.875C47.375 3.74783 46.9272 2.66683 46.1302 1.8698C45.3332 1.07277 44.2522 0.625 43.125 0.625ZM17.625 26.125H4.875C3.74783 26.125 2.66683 26.5728 1.8698 27.3698C1.07277 28.1668 0.625 29.2478 0.625 30.375V43.125C0.625 44.2522 1.07277 45.3332 1.8698 46.1302C2.66683 46.9272 3.74783 47.375 4.875 47.375H17.625C18.7522 47.375 19.8332 46.9272 20.6302 46.1302C21.4272 45.3332 21.875 44.2522 21.875 43.125V30.375C21.875 29.2478 21.4272 28.1668 20.6302 27.3698C19.8332 26.5728 18.7522 26.125 17.625 26.125ZM43.125 26.125H30.375C29.2478 26.125 28.1668 26.5728 27.3698 27.3698C26.5728 28.1668 26.125 29.2478 26.125 30.375V43.125C26.125 44.2522 26.5728 45.3332 27.3698 46.1302C28.1668 46.9272 29.2478 47.375 30.375 47.375H43.125C44.2522 47.375 45.3332 46.9272 46.1302 46.1302C46.9272 45.3332 47.375 44.2522 47.375 43.125V30.375C47.375 29.2478 46.9272 28.1668 46.1302 27.3698C45.3332 26.5728 44.2522 26.125 43.125 26.125Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-dashboard"
              role="tabpanel"
              aria-labelledby="pills-dashboard-tab"
            >
              <div className="system_info_tabs_main">
                <div className="row">
                  <div className="col-lg-6 align-self-center">
                    <div className="system_info_tabs_content">
                      <div className="build_web_app-content-wrp">
                        <span className="system_info_tabs_content_tags">
                          Dashboard with Google Analytics
                        </span>
                        <h3>Real-time insights and analytics</h3>
                        <p>
                          Get a smart, real-time business overview with
                          integrated charts, order stats, and Google Analytics
                          insights.
                        </p>
                        <ul>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1066)">
                                  <path
                                    d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1066">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.355469)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Live Sales & Orders</strong> */}
                            – Monitor total users, orders, sales, and deliveries
                            in real-time.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1071)">
                                  <path
                                    d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1071">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.544678)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Monthly Charts</strong> */}
                            – Visualize online orders and sales trends month by
                            month.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1077)">
                                  <path
                                    d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1077">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.724609)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Order Status Tracking</strong> */}
                            – See counts of pending, delivered, and cancelled
                            orders at a glance.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Yearly Sales Comparison</strong> */}
                            – Compare this year’s and last year’s sales side by
                            side.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <strong>Google Analytics Sync</strong> */}
                            – View users, sessions, and engagement data directly
                            in your dashboard.
                          </li>
                        </ul>
                        <button
                          className="cmn-btn"
                          onClick={() =>
                            (window.location.href =
                              "https://register.launchestore.com")
                          }
                        >
                          <span className="cmn-btn-text1">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                          <span className="cmn-btn-text2">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                        </button>

                        <div className="build_web_app-content-profile d-none">
                          <p>
                            “LaunchEstore transformed my online business!
                            Setting up my store was so simple, and their
                            customer support is always there to help. Thanks to
                            their tools, I reached new customers and saw sales
                            skyrocket. Highly recommended!”
                          </p>
                          <div className="build_web_app-profile-inner d-none">
                            <div className="build_web_app-profile-img">
                              <img src={profileimg} alt="" />
                            </div>
                            <div className="build_web_app-profile-content">
                              <h4>Priya Mehta</h4>
                              <p>Jwellery Owner</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="system_info_tabs_img">
                      <img src={dashbordtabsimg} alt={dashbordtabsimg} />
                      <div className="system_info_tabs_img_icon1">
                        <svg
                          width="52"
                          height="46"
                          viewBox="0 0 52 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M51.1875 43.375C51.1875 43.8889 50.9834 44.3817 50.62 44.745C50.2567 45.1084 49.7639 45.3125 49.25 45.3125H2.75C2.23614 45.3125 1.74333 45.1084 1.37998 44.745C1.01663 44.3817 0.8125 43.8889 0.8125 43.375C0.8125 42.8611 1.01663 42.3683 1.37998 42.005C1.74333 41.6416 2.23614 41.4375 2.75 41.4375H4.6875V25.9375C4.6875 25.4236 4.89163 24.9308 5.25498 24.5675C5.61833 24.2041 6.11114 24 6.625 24H12.4375C12.9514 24 13.4442 24.2041 13.8075 24.5675C14.1709 24.9308 14.375 25.4236 14.375 25.9375V41.4375H18.25V14.3125C18.25 13.7986 18.4541 13.3058 18.8175 12.9425C19.1808 12.5791 19.6736 12.375 20.1875 12.375H27.9375C28.4514 12.375 28.9442 12.5791 29.3075 12.9425C29.6709 13.3058 29.875 13.7986 29.875 14.3125V41.4375H33.75V2.6875C33.75 2.17364 33.9541 1.68083 34.3175 1.31748C34.6808 0.954129 35.1736 0.75 35.6875 0.75H45.375C45.8889 0.75 46.3817 0.954129 46.745 1.31748C47.1084 1.68083 47.3125 2.17364 47.3125 2.6875V41.4375H49.25C49.7639 41.4375 50.2567 41.6416 50.62 42.005C50.9834 42.3683 51.1875 42.8611 51.1875 43.375Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="system_info_tabs_img_icon2">
                        <svg
                          width="74"
                          height="55"
                          viewBox="0 0 74 55"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.5357 31.0328C17.544 31.1979 17.5186 31.363 17.4611 31.518C17.4035 31.6729 17.3151 31.8146 17.2011 31.9343C17.0871 32.054 16.9499 32.1492 16.7979 32.2143C16.6459 32.2793 16.4823 32.3127 16.317 32.3125H2.87418C2.32402 32.3133 1.78976 32.128 1.35828 31.7867C0.926793 31.4454 0.623465 30.9682 0.497617 30.4326C0.419254 30.066 0.422866 29.6866 0.508195 29.3216C0.593525 28.9566 0.758462 28.615 0.99121 28.3211C3.14172 25.4692 5.99506 23.2237 9.27262 21.8038C7.83366 20.4919 6.73002 18.8542 6.05413 17.028C5.37824 15.2018 5.14978 13.2402 5.38789 11.3075C5.626 9.37484 6.32374 7.52737 7.42267 5.91982C8.52161 4.31226 9.98974 2.99143 11.7041 2.06795C13.4185 1.14447 15.3292 0.645227 17.2762 0.612031C19.2232 0.578836 21.1498 1.01265 22.8946 1.87716C24.6395 2.74166 26.1518 4.01167 27.3049 5.58083C28.458 7.14998 29.2183 8.9726 29.5221 10.896C29.5614 11.1547 29.5151 11.4191 29.3902 11.649C29.2654 11.8789 29.0688 12.0617 28.8305 12.1696C25.4497 13.7326 22.5864 16.23 20.5787 19.3672C18.5709 22.5044 17.5024 26.1504 17.4992 29.875C17.4992 30.265 17.4992 30.6489 17.5357 31.0328ZM72.9889 28.3181C70.8433 25.4694 67.9965 23.2251 64.7257 21.8038C66.1647 20.4919 67.2683 18.8542 67.9442 17.028C68.6201 15.2018 68.8486 13.2402 68.6105 11.3075C68.3724 9.37484 67.6746 7.52737 66.5757 5.91982C65.4768 4.31226 64.0086 2.99143 62.2942 2.06795C60.5799 1.14447 58.6692 0.645227 56.7222 0.612031C54.7752 0.578836 52.8486 1.01265 51.1037 1.87716C49.3589 2.74166 47.8466 4.01167 46.6935 5.58083C45.5404 7.14998 44.7801 8.9726 44.4762 10.896C44.437 11.1547 44.4833 11.4191 44.6082 11.649C44.733 11.8789 44.9295 12.0617 45.1679 12.1696C48.5487 13.7326 51.4119 16.23 53.4197 19.3672C55.4275 22.5044 56.496 26.1504 56.4992 29.875C56.4992 30.265 56.4992 30.6489 56.4626 31.0328C56.4544 31.1979 56.4798 31.363 56.5373 31.518C56.5948 31.6729 56.6833 31.8146 56.7973 31.9343C56.9113 32.054 57.0485 32.1492 57.2005 32.2143C57.3524 32.2793 57.5161 32.3127 57.6814 32.3125H71.1242C71.6743 32.3133 72.2086 32.128 72.6401 31.7867C73.0716 31.4454 73.3749 30.9682 73.5007 30.4326C73.5796 30.0653 73.5759 29.6852 73.4901 29.3195C73.4042 28.9538 73.2382 28.6118 73.0041 28.3181H72.9889ZM45.8717 41.4745C48.2987 39.6158 50.0822 37.0433 50.9716 34.1186C51.8611 31.1939 51.8117 28.064 50.8304 25.1688C49.8491 22.2736 47.9853 19.7587 45.5009 17.9775C43.0165 16.1963 40.0363 15.2384 36.9794 15.2384C33.9224 15.2384 30.9423 16.1963 28.4579 17.9775C25.9734 19.7587 24.1096 22.2736 23.1283 25.1688C22.1471 28.064 22.0977 31.1939 22.9871 34.1186C23.8765 37.0433 25.6601 39.6158 28.0871 41.4745C23.7804 43.3405 20.1843 46.5362 17.8252 50.5938C17.6112 50.9643 17.4986 51.3847 17.4986 51.8126C17.4987 52.2406 17.6113 52.6609 17.8253 53.0315C18.0393 53.4021 18.3471 53.7098 18.7177 53.9236C19.0884 54.1375 19.5088 54.2501 19.9367 54.25H54.0617C54.4896 54.2501 54.91 54.1375 55.2806 53.9236C55.6512 53.7098 55.959 53.4021 56.173 53.0315C56.387 52.6609 56.4997 52.2406 56.4997 51.8126C56.4998 51.3847 56.3871 50.9643 56.1732 50.5938C53.809 46.5335 50.2062 43.3376 45.893 41.4745H45.8717Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-inventory"
              role="tabpanel"
              aria-labelledby="pills-inventory-tab"
            >
              <div className="system_info_tabs_main">
                <div className="row">
                  <div className="col-lg-6 align-self-center">
                    <div className="system_info_tabs_content">
                      <div className="build_web_app-content-wrp">
                        <span className="system_info_tabs_content_tags">
                          Inventory Management
                        </span>
                        <h3>Live stock tracking and control</h3>
                        <p>
                          Manage product stock across branches and warehouses
                          with auto updates from sales and purchase activity.
                        </p>
                        <ul>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1066)">
                                  <path
                                    d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1066">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.355469)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Stock increases with purchases and decreases with
                            every sale.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1071)">
                                  <path
                                    d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1071">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.544678)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Receive inventory through purchase invoices or
                            orders.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1077)">
                                  <path
                                    d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1077">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.724609)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Track item-wise stock movement in a detailed
                            ledger view.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Handle inventory distribution per location or
                            vendor.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – All channels sync with inventory for real-time
                            accuracy.
                          </li>
                        </ul>
                        <button
                          className="cmn-btn"
                          onClick={() =>
                            (window.location.href =
                              "https://register.launchestore.com")
                          }
                        >
                          <span className="cmn-btn-text1">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                          <span className="cmn-btn-text2">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                        </button>

                        <div className="build_web_app-content-profile d-none">
                          <p>
                            “LaunchEstore transformed my online business!
                            Setting up my store was so simple, and their
                            customer support is always there to help. Thanks to
                            their tools, I reached new customers and saw sales
                            skyrocket. Highly recommended!”
                          </p>
                          <div className="build_web_app-profile-inner d-none">
                            <div className="build_web_app-profile-img">
                              <img src={profileimg} alt="" />
                            </div>
                            <div className="build_web_app-profile-content">
                              <h4>Priya Mehta</h4>
                              <p>Jwellery Owner</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="system_info_tabs_img">
                      <img src={inventroytabsimg} alt={inventroytabsimg} />
                      <div className="system_info_tabs_img_icon1">
                        <svg
                          width="44"
                          height="36"
                          viewBox="0 0 44 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.5 0.125H2.5C2.06902 0.125 1.6557 0.296205 1.35095 0.600952C1.0462 0.905698 0.875 1.31902 0.875 1.75V34.25C0.875 34.681 1.0462 35.0943 1.35095 35.399C1.6557 35.7038 2.06902 35.875 2.5 35.875H41.5C41.931 35.875 42.3443 35.7038 42.649 35.399C42.9538 35.0943 43.125 34.681 43.125 34.25V1.75C43.125 1.31902 42.9538 0.905698 42.649 0.600952C42.3443 0.296205 41.931 0.125 41.5 0.125ZM4.125 5C4.125 4.56902 4.29621 4.1557 4.60095 3.85095C4.9057 3.54621 5.31902 3.375 5.75 3.375H12.25C12.681 3.375 13.0943 3.54621 13.399 3.85095C13.7038 4.1557 13.875 4.56902 13.875 5C13.875 5.43098 13.7038 5.8443 13.399 6.14905C13.0943 6.45379 12.681 6.625 12.25 6.625H7.375V11.5C7.375 11.931 7.20379 12.3443 6.89905 12.649C6.5943 12.9538 6.18098 13.125 5.75 13.125C5.31902 13.125 4.9057 12.9538 4.60095 12.649C4.29621 12.3443 4.125 11.931 4.125 11.5V5ZM12.25 32.625H5.75C5.31902 32.625 4.9057 32.4538 4.60095 32.149C4.29621 31.8443 4.125 31.431 4.125 31V24.5C4.125 24.069 4.29621 23.6557 4.60095 23.351C4.9057 23.0462 5.31902 22.875 5.75 22.875C6.18098 22.875 6.5943 23.0462 6.89905 23.351C7.20379 23.6557 7.375 24.069 7.375 24.5V29.375H12.25C12.681 29.375 13.0943 29.5462 13.399 29.851C13.7038 30.1557 13.875 30.569 13.875 31C13.875 31.431 13.7038 31.8443 13.399 32.149C13.0943 32.4538 12.681 32.625 12.25 32.625ZM17.125 22.875C17.125 23.306 16.9538 23.7193 16.649 24.024C16.3443 24.3288 15.931 24.5 15.5 24.5C15.069 24.5 14.6557 24.3288 14.351 24.024C14.0462 23.7193 13.875 23.306 13.875 22.875V13.125C13.875 12.694 14.0462 12.2807 14.351 11.976C14.6557 11.6712 15.069 11.5 15.5 11.5C15.931 11.5 16.3443 11.6712 16.649 11.976C16.9538 12.2807 17.125 12.694 17.125 13.125V22.875ZM23.625 22.875C23.625 23.306 23.4538 23.7193 23.149 24.024C22.8443 24.3288 22.431 24.5 22 24.5C21.569 24.5 21.1557 24.3288 20.851 24.024C20.5462 23.7193 20.375 23.306 20.375 22.875V13.125C20.375 12.694 20.5462 12.2807 20.851 11.976C21.1557 11.6712 21.569 11.5 22 11.5C22.431 11.5 22.8443 11.6712 23.149 11.976C23.4538 12.2807 23.625 12.694 23.625 13.125V22.875ZM28.5 24.5C28.069 24.5 27.6557 24.3288 27.351 24.024C27.0462 23.7193 26.875 23.306 26.875 22.875V13.125C26.875 12.694 27.0462 12.2807 27.351 11.976C27.6557 11.6712 28.069 11.5 28.5 11.5C28.931 11.5 29.3443 11.6712 29.649 11.976C29.9538 12.2807 30.125 12.694 30.125 13.125V22.875C30.125 23.306 29.9538 23.7193 29.649 24.024C29.3443 24.3288 28.931 24.5 28.5 24.5ZM39.875 31C39.875 31.431 39.7038 31.8443 39.399 32.149C39.0943 32.4538 38.681 32.625 38.25 32.625H31.75C31.319 32.625 30.9057 32.4538 30.601 32.149C30.2962 31.8443 30.125 31.431 30.125 31C30.125 30.569 30.2962 30.1557 30.601 29.851C30.9057 29.5462 31.319 29.375 31.75 29.375H36.625V24.5C36.625 24.069 36.7962 23.6557 37.101 23.351C37.4057 23.0462 37.819 22.875 38.25 22.875C38.681 22.875 39.0943 23.0462 39.399 23.351C39.7038 23.6557 39.875 24.069 39.875 24.5V31ZM39.875 11.5C39.875 11.931 39.7038 12.3443 39.399 12.649C39.0943 12.9538 38.681 13.125 38.25 13.125C37.819 13.125 37.4057 12.9538 37.101 12.649C36.7962 12.3443 36.625 11.931 36.625 11.5V6.625H31.75C31.319 6.625 30.9057 6.45379 30.601 6.14905C30.2962 5.8443 30.125 5.43098 30.125 5C30.125 4.56902 30.2962 4.1557 30.601 3.85095C30.9057 3.54621 31.319 3.375 31.75 3.375H38.25C38.681 3.375 39.0943 3.54621 39.399 3.85095C39.7038 4.1557 39.875 4.56902 39.875 5V11.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="system_info_tabs_img_icon2">
                        <svg
                          width="52"
                          height="52"
                          viewBox="0 0 52 52"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M50.9391 10.7977C50.7631 10.587 50.5429 10.4176 50.2943 10.3014C50.0456 10.1852 49.7745 10.125 49.5 10.125H11.6906L10.2656 2.28984C10.1871 1.85781 9.95951 1.46704 9.62243 1.18564C9.28535 0.904235 8.86019 0.750063 8.42109 0.75H2.625C2.12772 0.75 1.65081 0.947544 1.29917 1.29917C0.947544 1.65081 0.75 2.12772 0.75 2.625C0.75 3.12228 0.947544 3.59919 1.29917 3.95083C1.65081 4.30246 2.12772 4.5 2.625 4.5H6.84375L12.8344 37.3805C13.0108 38.3556 13.4418 39.2668 14.0836 40.0219C13.1978 40.8493 12.5584 41.9058 12.2364 43.0744C11.9144 44.243 11.9223 45.4779 12.2593 46.6422C12.5963 47.8066 13.2492 48.8548 14.1455 49.6708C15.0419 50.4867 16.1468 51.0385 17.3376 51.2648C18.5284 51.4912 19.7586 51.3833 20.8918 50.9532C22.0251 50.5231 23.017 49.7875 23.7578 48.828C24.4985 47.8685 24.959 46.7226 25.0882 45.5174C25.2174 44.3122 25.0103 43.0947 24.4898 42H35.1352C34.7157 42.8782 34.4986 43.8393 34.5 44.8125C34.5 46.1104 34.8849 47.3792 35.606 48.4584C36.3271 49.5376 37.352 50.3788 38.5511 50.8755C39.7503 51.3722 41.0698 51.5021 42.3428 51.2489C43.6158 50.9957 44.7851 50.3707 45.7029 49.4529C46.6207 48.5351 47.2457 47.3658 47.4989 46.0928C47.7521 44.8198 47.6222 43.5003 47.1255 42.3011C46.6288 41.102 45.7876 40.0771 44.7084 39.356C43.6292 38.6349 42.3604 38.25 41.0625 38.25H18.368C17.9289 38.2499 17.5037 38.0958 17.1666 37.8144C16.8296 37.533 16.6019 37.1422 16.5234 36.7102L15.7805 32.625H42.968C44.2853 32.6248 45.5607 32.1623 46.572 31.3181C47.5832 30.4739 48.2661 29.3016 48.5016 28.0055L51.3516 12.3352C51.3998 12.0643 51.3879 11.7862 51.3166 11.5205C51.2453 11.2547 51.1164 11.008 50.9391 10.7977ZM21.375 44.8125C21.375 45.3688 21.2101 45.9125 20.901 46.375C20.592 46.8376 20.1527 47.198 19.6388 47.4109C19.1249 47.6238 18.5594 47.6795 18.0138 47.571C17.4682 47.4624 16.9671 47.1946 16.5738 46.8012C16.1804 46.4079 15.9126 45.9068 15.804 45.3612C15.6955 44.8156 15.7512 44.2501 15.9641 43.7362C16.177 43.2223 16.5374 42.783 17 42.474C17.4625 42.165 18.0062 42 18.5625 42C19.3084 42 20.0238 42.2963 20.5512 42.8238C21.0787 43.3512 21.375 44.0666 21.375 44.8125ZM43.875 44.8125C43.875 45.3688 43.7101 45.9125 43.401 46.375C43.092 46.8376 42.6527 47.198 42.1388 47.4109C41.6249 47.6238 41.0594 47.6795 40.5138 47.571C39.9682 47.4624 39.4671 47.1946 39.0738 46.8012C38.6804 46.4079 38.4126 45.9068 38.304 45.3612C38.1955 44.8156 38.2512 44.2501 38.4641 43.7362C38.677 43.2223 39.0374 42.783 39.5 42.474C39.9625 42.165 40.5062 42 41.0625 42C41.8084 42 42.5238 42.2963 43.0512 42.8238C43.5787 43.3512 43.875 44.0666 43.875 44.8125Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-invoice"
              role="tabpanel"
              aria-labelledby="pills-invoice-tab"
            >
              <div className="system_info_tabs_main">
                <div className="row">
                  <div className="col-lg-6 align-self-center">
                    <div className="system_info_tabs_content">
                      <div className="build_web_app-content-wrp">
                        <span className="system_info_tabs_content_tags">
                          Invoice Management
                        </span>
                        <h3>Custom smart invoicing system</h3>
                        <p>
                          Generate smart, professional invoices with automatic
                          data fill and easy sharing via app or email.
                        </p>
                        <ul>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1066)">
                                  <path
                                    d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1066">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.355469)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Choose from multiple designs to suit your business
                            style.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1071)">
                                  <path
                                    d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1071">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.544678)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Vendor and customer data is auto-fetched for
                            accuracy.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1077)">
                                  <path
                                    d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1077">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.724609)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Create and download invoice PDFs instantly.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Send invoices directly to customers via email or
                            through the app.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Deliver professional, business-branded invoices
                            every time.
                          </li>
                        </ul>
                        <button
                          className="cmn-btn"
                          onClick={() =>
                            (window.location.href =
                              "https://register.launchestore.com")
                          }
                        >
                          <span className="cmn-btn-text1">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                          <span className="cmn-btn-text2">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                        </button>

                        <div className="build_web_app-content-profile d-none">
                          <p>
                            “LaunchEstore transformed my online business!
                            Setting up my store was so simple, and their
                            customer support is always there to help. Thanks to
                            their tools, I reached new customers and saw sales
                            skyrocket. Highly recommended!”
                          </p>
                          <div className="build_web_app-profile-inner d-none">
                            <div className="build_web_app-profile-img">
                              <img src={profileimg} alt="" />
                            </div>
                            <div className="build_web_app-profile-content">
                              <h4>Priya Mehta</h4>
                              <p>Jwellery Owner</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="system_info_tabs_img">
                      <img src={invoicetabsimg} alt={invoicetabsimg} />
                      <div className="system_info_tabs_img_icon1">
                        <svg
                          width="41"
                          height="32"
                          viewBox="0 0 41 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.25 17C1.85218 17 1.47064 16.842 1.18934 16.5607C0.908035 16.2794 0.75 15.8978 0.75 15.5C0.75 15.1022 0.908035 14.7206 1.18934 14.4393C1.47064 14.158 1.85218 14 2.25 14H7.5C7.89782 14 8.27935 13.842 8.56066 13.5607C8.84196 13.2794 9 12.8978 9 12.5C9 12.1022 8.84196 11.7206 8.56066 11.4393C8.27935 11.158 7.89782 11 7.5 11H4.5C3.30653 11 2.16193 10.5259 1.31802 9.68198C0.474106 8.83807 0 7.69347 0 6.5C0 5.30653 0.474106 4.16193 1.31802 3.31802C2.16193 2.47411 3.30653 2 4.5 2C4.5 1.60218 4.65804 1.22064 4.93934 0.93934C5.22064 0.658036 5.60218 0.5 6 0.5C6.39782 0.5 6.77936 0.658036 7.06066 0.93934C7.34196 1.22064 7.5 1.60218 7.5 2H9C9.39782 2 9.77935 2.15804 10.0607 2.43934C10.342 2.72064 10.5 3.10218 10.5 3.5C10.5 3.89782 10.342 4.27936 10.0607 4.56066C9.77935 4.84196 9.39782 5 9 5H4.5C4.10218 5 3.72064 5.15804 3.43934 5.43934C3.15804 5.72064 3 6.10218 3 6.5C3 6.89782 3.15804 7.27936 3.43934 7.56066C3.72064 7.84196 4.10218 8 4.5 8H7.5C8.69347 8 9.83807 8.47411 10.682 9.31802C11.5259 10.1619 12 11.3065 12 12.5C12 13.6935 11.5259 14.8381 10.682 15.682C9.83807 16.5259 8.69347 17 7.5 17C7.5 17.3978 7.34196 17.7794 7.06066 18.0607C6.77936 18.342 6.39782 18.5 6 18.5C5.60218 18.5 5.22064 18.342 4.93934 18.0607C4.65804 17.7794 4.5 17.3978 4.5 17H2.25ZM39 2H15C14.6022 2 14.2206 2.15804 13.9393 2.43934C13.658 2.72064 13.5 3.10218 13.5 3.5C13.5 3.89782 13.658 4.27936 13.9393 4.56066C14.2206 4.84196 14.6022 5 15 5H37.5V11H16.5C16.1022 11 15.7206 11.158 15.4393 11.4393C15.158 11.7206 15 12.1022 15 12.5C15 12.8978 15.158 13.2794 15.4393 13.5607C15.7206 13.842 16.1022 14 16.5 14H27V20H12C11.6022 20 11.2206 20.158 10.9393 20.4393C10.658 20.7206 10.5 21.1022 10.5 21.5C10.5 21.8978 10.658 22.2794 10.9393 22.5607C11.2206 22.842 11.6022 23 12 23H27V29H4.5V21.5C4.5 21.1022 4.34196 20.7206 4.06066 20.4393C3.77936 20.158 3.39782 20 3 20C2.60218 20 2.22064 20.158 1.93934 20.4393C1.65804 20.7206 1.5 21.1022 1.5 21.5V29C1.5 29.7956 1.81607 30.5587 2.37868 31.1213C2.94129 31.6839 3.70435 32 4.5 32H37.5C38.2956 32 39.0587 31.6839 39.6213 31.1213C40.1839 30.5587 40.5 29.7956 40.5 29V3.5C40.5 3.10218 40.342 2.72064 40.0607 2.43934C39.7794 2.15804 39.3978 2 39 2Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="system_info_tabs_img_icon2">
                        <svg
                          width="44"
                          height="36"
                          viewBox="0 0 44 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.875 0.125H4.125C3.26305 0.125 2.4364 0.46741 1.8269 1.0769C1.21741 1.6864 0.875 2.51305 0.875 3.375V34.25C0.875148 34.527 0.946083 34.7993 1.08107 35.0411C1.21606 35.283 1.41062 35.4863 1.64628 35.6318C1.88194 35.7773 2.15088 35.8602 2.42757 35.8725C2.70425 35.8849 2.9795 35.8263 3.22719 35.7023L9 32.8159L14.7728 35.7023C14.9986 35.8153 15.2476 35.8741 15.5 35.8741C15.7524 35.8741 16.0014 35.8153 16.2272 35.7023L22 32.8159L27.7728 35.7023C27.9986 35.8153 28.2476 35.8741 28.5 35.8741C28.7524 35.8741 29.0014 35.8153 29.2272 35.7023L35 32.8159L40.7728 35.7023C41.0205 35.8263 41.2957 35.8849 41.5724 35.8725C41.8491 35.8602 42.1181 35.7773 42.3537 35.6318C42.5894 35.4863 42.7839 35.283 42.9189 35.0411C43.0539 34.7993 43.1249 34.527 43.125 34.25V3.375C43.125 2.51305 42.7826 1.6864 42.1731 1.0769C41.5636 0.46741 40.737 0.125 39.875 0.125ZM31.75 21.25H12.25C11.819 21.25 11.4057 21.0788 11.101 20.774C10.7962 20.4693 10.625 20.056 10.625 19.625C10.625 19.194 10.7962 18.7807 11.101 18.4759C11.4057 18.1712 11.819 18 12.25 18H31.75C32.181 18 32.5943 18.1712 32.899 18.4759C33.2038 18.7807 33.375 19.194 33.375 19.625C33.375 20.056 33.2038 20.4693 32.899 20.774C32.5943 21.0788 32.181 21.25 31.75 21.25ZM31.75 14.75H12.25C11.819 14.75 11.4057 14.5788 11.101 14.274C10.7962 13.9693 10.625 13.556 10.625 13.125C10.625 12.694 10.7962 12.2807 11.101 11.976C11.4057 11.6712 11.819 11.5 12.25 11.5H31.75C32.181 11.5 32.5943 11.6712 32.899 11.976C33.2038 12.2807 33.375 12.694 33.375 13.125C33.375 13.556 33.2038 13.9693 32.899 14.274C32.5943 14.5788 32.181 14.75 31.75 14.75Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-sales"
              role="tabpanel"
              aria-labelledby="pills-sales-tab"
            >
              <div className="system_info_tabs_main">
                <div className="row">
                  <div className="col-lg-6 align-self-center">
                    <div className="system_info_tabs_content">
                      <div className="build_web_app-content-wrp">
                        <span className="system_info_tabs_content_tags">
                          Sales & Purchase
                        </span>
                        <h3>Manage orders and billing flow</h3>
                        <p>
                          Easily manage orders, invoices, and linked payments
                          for both sales and purchases—all in one place.
                        </p>
                        <ul>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1066)">
                                  <path
                                    d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1066">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.355469)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Generate sales/purchase orders and invoices in
                            just a few clicks.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1071)">
                                  <path
                                    d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1071">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.544678)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Record incoming and outgoing payments linked to
                            orders.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1077)">
                                  <path
                                    d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1077">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.724609)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Inventory adjusts automatically with each
                            transaction.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Transactions reflect in financial reports and
                            daily balance.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Access sales and purchase summaries with filters
                            and charts.
                          </li>
                        </ul>
                        <button
                          className="cmn-btn"
                          onClick={() =>
                            (window.location.href =
                              "https://register.launchestore.com")
                          }
                        >
                          <span className="cmn-btn-text1">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                          <span className="cmn-btn-text2">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                        </button>

                        <div className="build_web_app-content-profile d-none">
                          <p>
                            “LaunchEstore transformed my online business!
                            Setting up my store was so simple, and their
                            customer support is always there to help. Thanks to
                            their tools, I reached new customers and saw sales
                            skyrocket. Highly recommended!”
                          </p>
                          <div className="build_web_app-profile-inner d-none">
                            <div className="build_web_app-profile-img">
                              <img src={profileimg} alt="" />
                            </div>
                            <div className="build_web_app-profile-content">
                              <h4>Priya Mehta</h4>
                              <p>Jwellery Owner</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="system_info_tabs_img">
                      <img src={salestabsimg} alt={salestabsimg} />
                      <div className="system_info_tabs_img_icon1">
                        <svg
                          width="58"
                          height="58"
                          viewBox="0 0 58 58"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.75 22.8125C20.3421 22.8125 19.9433 22.6915 19.6041 22.4649C19.265 22.2383 19.0006 21.9162 18.8445 21.5393C18.6884 21.1624 18.6475 20.7477 18.7271 20.3476C18.8067 19.9475 19.0031 19.58 19.2916 19.2916C19.58 19.0031 19.9475 18.8067 20.3476 18.7271C20.7477 18.6475 21.1624 18.6884 21.5393 18.8445C21.9162 19.0006 22.2383 19.265 22.4649 19.6041C22.6915 19.9433 22.8125 20.3421 22.8125 20.75C22.8125 21.297 22.5952 21.8216 22.2084 22.2084C21.8216 22.5952 21.297 22.8125 20.75 22.8125ZM37.25 35.1875C36.8421 35.1875 36.4433 35.3085 36.1041 35.5351C35.765 35.7617 35.5006 36.0838 35.3445 36.4607C35.1884 36.8376 35.1475 37.2523 35.2271 37.6524C35.3067 38.0525 35.5031 38.42 35.7916 38.7084C36.08 38.9969 36.4475 39.1933 36.8476 39.2729C37.2477 39.3525 37.6624 39.3116 38.0393 39.1555C38.4162 38.9994 38.7383 38.735 38.9649 38.3959C39.1915 38.0567 39.3125 37.6579 39.3125 37.25C39.3125 36.703 39.0952 36.1784 38.7084 35.7916C38.3216 35.4048 37.797 35.1875 37.25 35.1875ZM57.875 29C57.875 31.6916 55.9388 33.7102 54.2295 35.4917C53.2576 36.5075 52.2521 37.5542 51.8731 38.4746C51.5225 39.3177 51.5019 40.715 51.4813 42.0685C51.4426 44.5848 51.4013 47.4362 49.4188 49.4188C47.4362 51.4013 44.5848 51.4426 42.0685 51.4813C40.715 51.5019 39.3177 51.5225 38.4746 51.8731C37.5542 52.2521 36.5075 53.2576 35.4917 54.2295C33.7102 55.9388 31.6916 57.875 29 57.875C26.3084 57.875 24.2898 55.9388 22.5083 54.2295C21.4925 53.2576 20.4458 52.2521 19.5254 51.8731C18.6823 51.5225 17.285 51.5019 15.9315 51.4813C13.4152 51.4426 10.5638 51.4013 8.58125 49.4188C6.59867 47.4362 6.55742 44.5848 6.51875 42.0685C6.49812 40.715 6.4775 39.3177 6.12687 38.4746C5.74789 37.5542 4.74242 36.5075 3.77047 35.4917C2.06117 33.7102 0.125 31.6916 0.125 29C0.125 26.3084 2.06117 24.2898 3.77047 22.5083C4.74242 21.4925 5.74789 20.4458 6.12687 19.5254C6.4775 18.6823 6.49812 17.285 6.51875 15.9315C6.55742 13.4152 6.59867 10.5638 8.58125 8.58125C10.5638 6.59867 13.4152 6.55742 15.9315 6.51875C17.285 6.49812 18.6823 6.4775 19.5254 6.12687C20.4458 5.74789 21.4925 4.74242 22.5083 3.77047C24.2898 2.06117 26.3084 0.125 29 0.125C31.6916 0.125 33.7102 2.06117 35.4917 3.77047C36.5075 4.74242 37.5542 5.74789 38.4746 6.12687C39.3177 6.4775 40.715 6.49812 42.0685 6.51875C44.5848 6.55742 47.4362 6.59867 49.4188 8.58125C51.4013 10.5638 51.4426 13.4152 51.4813 15.9315C51.5019 17.285 51.5225 18.6823 51.8731 19.5254C52.2521 20.4458 53.2576 21.4925 54.2295 22.5083C55.9388 24.2898 57.875 26.3084 57.875 29ZM20.75 26.9375C21.9738 26.9375 23.1701 26.5746 24.1876 25.8947C25.2051 25.2148 25.9982 24.2485 26.4665 23.1179C26.9348 21.9872 27.0574 20.7431 26.8186 19.5429C26.5799 18.3426 25.9906 17.2401 25.1252 16.3748C24.2599 15.5094 23.1574 14.9201 21.9571 14.6814C20.7569 14.4426 19.5128 14.5652 18.3821 15.0335C17.2515 15.5018 16.2852 16.2949 15.6053 17.3124C14.9254 18.3299 14.5625 19.5262 14.5625 20.75C14.5625 22.391 15.2144 23.9648 16.3748 25.1252C17.5352 26.2856 19.109 26.9375 20.75 26.9375ZM40.7717 20.1467C40.9633 19.9551 41.1154 19.7276 41.2191 19.4772C41.3228 19.2269 41.3761 18.9585 41.3761 18.6875C41.3761 18.4165 41.3228 18.1481 41.2191 17.8978C41.1154 17.6474 40.9633 17.4199 40.7717 17.2283C40.5801 17.0367 40.3526 16.8846 40.1022 16.7809C39.8519 16.6772 39.5835 16.6239 39.3125 16.6239C39.0415 16.6239 38.7731 16.6772 38.5228 16.7809C38.2724 16.8846 38.0449 17.0367 37.8533 17.2283L17.2283 37.8533C17.0367 38.0449 16.8846 38.2724 16.7809 38.5228C16.6772 38.7731 16.6239 39.0415 16.6239 39.3125C16.6239 39.5835 16.6772 39.8519 16.7809 40.1022C16.8846 40.3526 17.0367 40.5801 17.2283 40.7717C17.6153 41.1587 18.1402 41.3761 18.6875 41.3761C18.9585 41.3761 19.2269 41.3228 19.4772 41.2191C19.7276 41.1154 19.9551 40.9633 20.1467 40.7717L40.7717 20.1467ZM43.4375 37.25C43.4375 36.0262 43.0746 34.8299 42.3947 33.8124C41.7148 32.7949 40.7485 32.0018 39.6179 31.5335C38.4872 31.0652 37.2431 30.9426 36.0429 31.1814C34.8426 31.4201 33.7401 32.0094 32.8748 32.8748C32.0094 33.7401 31.4201 34.8426 31.1814 36.0429C30.9426 37.2431 31.0652 38.4872 31.5335 39.6179C32.0018 40.7485 32.7949 41.7148 33.8124 42.3947C34.8299 43.0746 36.0262 43.4375 37.25 43.4375C38.891 43.4375 40.4648 42.7856 41.6252 41.6252C42.7856 40.4648 43.4375 38.891 43.4375 37.25Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="system_info_tabs_img_icon2">
                        <svg
                          width="48"
                          height="40"
                          viewBox="0 0 48 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M43.9375 0.0625H4.0625C3.10109 0.0625 2.17906 0.444418 1.49924 1.12424C0.819418 1.80406 0.4375 2.72609 0.4375 3.6875V38.125C0.437665 38.4339 0.516785 38.7377 0.667347 39.0074C0.81791 39.2772 1.03492 39.5039 1.29777 39.6662C1.56062 39.8285 1.8606 39.921 2.16921 39.9347C2.47782 39.9485 2.78483 39.8832 3.06109 39.7449L9.5 36.5255L15.9389 39.7449C16.1907 39.8709 16.4684 39.9365 16.75 39.9365C17.0316 39.9365 17.3093 39.8709 17.5611 39.7449L24 36.5255L30.4389 39.7449C30.6907 39.8709 30.9684 39.9365 31.25 39.9365C31.5316 39.9365 31.8093 39.8709 32.0611 39.7449L38.5 36.5255L44.9389 39.7449C45.2152 39.8832 45.5222 39.9485 45.8308 39.9347C46.1394 39.921 46.4394 39.8285 46.7022 39.6662C46.9651 39.5039 47.1821 39.2772 47.3327 39.0074C47.4832 38.7377 47.5623 38.4339 47.5625 38.125V3.6875C47.5625 2.72609 47.1806 1.80406 46.5008 1.12424C45.8209 0.444418 44.8989 0.0625 43.9375 0.0625ZM34.875 23.625H13.125C12.6443 23.625 12.1833 23.434 11.8434 23.0941C11.5035 22.7542 11.3125 22.2932 11.3125 21.8125C11.3125 21.3318 11.5035 20.8708 11.8434 20.5309C12.1833 20.191 12.6443 20 13.125 20H34.875C35.3557 20 35.8167 20.191 36.1566 20.5309C36.4965 20.8708 36.6875 21.3318 36.6875 21.8125C36.6875 22.2932 36.4965 22.7542 36.1566 23.0941C35.8167 23.434 35.3557 23.625 34.875 23.625ZM34.875 16.375H13.125C12.6443 16.375 12.1833 16.184 11.8434 15.8441C11.5035 15.5042 11.3125 15.0432 11.3125 14.5625C11.3125 14.0818 11.5035 13.6208 11.8434 13.2809C12.1833 12.941 12.6443 12.75 13.125 12.75H34.875C35.3557 12.75 35.8167 12.941 36.1566 13.2809C36.4965 13.6208 36.6875 14.0818 36.6875 14.5625C36.6875 15.0432 36.4965 15.5042 36.1566 15.8441C35.8167 16.184 35.3557 16.375 34.875 16.375Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-product"
              role="tabpanel"
              aria-labelledby="pills-product-tab"
            >
              <div className="system_info_tabs_main">
                <div className="row">
                  <div className="col-lg-6 align-self-center">
                    <div className="system_info_tabs_content">
                      <div className="build_web_app-content-wrp">
                        <span className="system_info_tabs_content_tags">
                          Product Management
                        </span>
                        <h3>Powerful product setup tools</h3>
                        <p>
                          Add, organize, and control your product catalog with
                          optional detailed info, deals, and bulk import tools.
                        </p>
                        <ul>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1066)">
                                  <path
                                    d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1066">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.355469)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Create items for website, POS, or both.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1071)">
                                  <path
                                    d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1071">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.544678)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Add GST, variants, shipping info, or keep it
                            simple.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1077)">
                                  <path
                                    d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1077">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.724609)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Add products instantly by just name and price.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Save time by uploading hundreds of products at
                            once.
                          </li>
                          <li>
                            {/* <span>
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_941_1084)">
                                  <path
                                    d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                                    fill="#040404"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_941_1084">
                                    <rect
                                      width="17.9988"
                                      height="18.72"
                                      fill="white"
                                      transform="translate(0.000976562 0.916016)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span> */}
                            – Set up special deal products to boost your sales.
                          </li>
                        </ul>
                        <button
                          className="cmn-btn"
                          onClick={() =>
                            (window.location.href =
                              "https://register.launchestore.com")
                          }
                        >
                          <span className="cmn-btn-text1">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                          <span className="cmn-btn-text2">
                            Get Started{" "}
                            <MdOutlineArrowOutward className="button-icon" />
                          </span>
                        </button>

                        <div className="build_web_app-content-profile d-none">
                          <p>
                            “LaunchEstore transformed my online business!
                            Setting up my store was so simple, and their
                            customer support is always there to help. Thanks to
                            their tools, I reached new customers and saw sales
                            skyrocket. Highly recommended!”
                          </p>
                          <div className="build_web_app-profile-inner d-none">
                            <div className="build_web_app-profile-img">
                              <img src={profileimg} alt="" />
                            </div>
                            <div className="build_web_app-profile-content">
                              <h4>Priya Mehta</h4>
                              <p>Jwellery Owner</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="system_info_tabs_img">
                      <img src={producttabsimg} alt={producttabsimg} />
                      <div className="system_info_tabs_img_icon1">
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.3533 8.5782C39.2183 8.41673 39.0496 8.28685 38.859 8.19774C38.6683 8.10863 38.4604 8.06246 38.25 8.0625H9.26281L8.17031 2.05555C8.11014 1.72432 7.93562 1.42473 7.67719 1.20899C7.41877 0.993246 7.09282 0.875049 6.75617 0.875H2.3125C1.93125 0.875 1.56562 1.02645 1.29603 1.29603C1.02645 1.56562 0.875 1.93125 0.875 2.3125C0.875 2.69375 1.02645 3.05938 1.29603 3.32897C1.56562 3.59855 1.93125 3.75 2.3125 3.75H5.54688L10.1397 28.9584C10.275 29.706 10.6054 30.4046 11.0974 30.9834C10.4183 31.6178 9.92811 32.4278 9.68123 33.3237C9.43435 34.2196 9.44043 35.1664 9.69879 36.059C9.95714 36.9517 10.4577 37.7554 11.1449 38.3809C11.8321 39.0065 12.6792 39.4295 13.5921 39.603C14.5051 39.7766 15.4483 39.6939 16.3171 39.3641C17.1859 39.0343 17.9464 38.4704 18.5143 37.7348C19.0822 36.9992 19.4352 36.1207 19.5343 35.1967C19.6333 34.2727 19.4746 33.3393 19.0755 32.5H27.237C26.9154 33.1733 26.7489 33.9101 26.75 34.6562C26.75 35.6513 27.0451 36.6241 27.5979 37.4515C28.1508 38.2788 28.9365 38.9237 29.8559 39.3045C30.7752 39.6853 31.7868 39.785 32.7628 39.5908C33.7388 39.3967 34.6353 38.9175 35.3389 38.2139C36.0425 37.5103 36.5217 36.6138 36.7158 35.6378C36.91 34.6618 36.8103 33.6502 36.4295 32.7309C36.0487 31.8115 35.4038 31.0258 34.5765 30.4729C33.7491 29.9201 32.7763 29.625 31.7812 29.625H14.3821C14.0455 29.625 13.7195 29.5068 13.4611 29.291C13.2027 29.0753 13.0281 28.7757 12.968 28.4445L12.3984 25.3125H33.2421C34.252 25.3124 35.2299 24.9578 36.0052 24.3105C36.7805 23.6633 37.304 22.7645 37.4845 21.7709L39.6695 9.75695C39.7065 9.54931 39.6974 9.33606 39.6427 9.13235C39.5881 8.92864 39.4892 8.73945 39.3533 8.5782ZM16.6875 34.6562C16.6875 35.0827 16.561 35.4996 16.3241 35.8542C16.0872 36.2088 15.7504 36.4852 15.3564 36.6484C14.9624 36.8116 14.5289 36.8543 14.1106 36.7711C13.6923 36.6879 13.3081 36.4825 13.0066 36.1809C12.705 35.8794 12.4996 35.4952 12.4164 35.0769C12.3332 34.6586 12.3759 34.2251 12.5391 33.8311C12.7023 33.4371 12.9787 33.1003 13.3333 32.8634C13.6879 32.6265 14.1048 32.5 14.5312 32.5C15.1031 32.5 15.6516 32.7272 16.0559 33.1316C16.4603 33.5359 16.6875 34.0844 16.6875 34.6562ZM33.9375 34.6562C33.9375 35.0827 33.811 35.4996 33.5741 35.8542C33.3372 36.2088 33.0004 36.4852 32.6064 36.6484C32.2124 36.8116 31.7789 36.8543 31.3606 36.7711C30.9423 36.6879 30.5581 36.4825 30.2566 36.1809C29.955 35.8794 29.7496 35.4952 29.6664 35.0769C29.5832 34.6586 29.6259 34.2251 29.7891 33.8311C29.9523 33.4371 30.2287 33.1003 30.5833 32.8634C30.9379 32.6265 31.3548 32.5 31.7812 32.5C32.3531 32.5 32.9016 32.7272 33.3059 33.1316C33.7103 33.5359 33.9375 34.0844 33.9375 34.6562Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="system_info_tabs_img_icon2">
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M45.625 0.25H4.375C3.28098 0.25 2.23177 0.684597 1.45818 1.45818C0.684597 2.23177 0.25 3.28098 0.25 4.375V45.625C0.25 46.719 0.684597 47.7682 1.45818 48.5418C2.23177 49.3154 3.28098 49.75 4.375 49.75H45.625C46.719 49.75 47.7682 49.3154 48.5418 48.5418C49.3154 47.7682 49.75 46.719 49.75 45.625V4.375C49.75 3.28098 49.3154 2.23177 48.5418 1.45818C47.7682 0.684597 46.719 0.25 45.625 0.25ZM22.3342 30.5842L14.0842 38.8342C13.8927 39.026 13.6652 39.1781 13.4148 39.2819C13.1644 39.3857 12.896 39.4391 12.625 39.4391C12.354 39.4391 12.0856 39.3857 11.8352 39.2819C11.5848 39.1781 11.3573 39.026 11.1658 38.8342L7.04078 34.7092C6.65377 34.3222 6.43635 33.7973 6.43635 33.25C6.43635 32.7027 6.65377 32.1778 7.04078 31.7908C7.42779 31.4038 7.95269 31.1864 8.5 31.1864C9.04731 31.1864 9.57221 31.4038 9.95922 31.7908L12.625 34.4591L19.4158 27.6658C19.8028 27.2788 20.3277 27.0614 20.875 27.0614C21.4223 27.0614 21.9472 27.2788 22.3342 27.6658C22.7212 28.0528 22.9386 28.5777 22.9386 29.125C22.9386 29.6723 22.7212 30.1972 22.3342 30.5842ZM22.3342 14.0842L14.0842 22.3342C13.8927 22.526 13.6652 22.6781 13.4148 22.7819C13.1644 22.8857 12.896 22.9391 12.625 22.9391C12.354 22.9391 12.0856 22.8857 11.8352 22.7819C11.5848 22.6781 11.3573 22.526 11.1658 22.3342L7.04078 18.2092C6.84915 18.0176 6.69715 17.7901 6.59344 17.5397C6.48973 17.2894 6.43635 17.021 6.43635 16.75C6.43635 16.2027 6.65377 15.6778 7.04078 15.2908C7.42779 14.9038 7.95269 14.6864 8.5 14.6864C9.04731 14.6864 9.57221 14.9038 9.95922 15.2908L12.625 17.9591L19.4158 11.1658C19.8028 10.7788 20.3277 10.5614 20.875 10.5614C21.4223 10.5614 21.9472 10.7788 22.3342 11.1658C22.7212 11.5528 22.9386 12.0777 22.9386 12.625C22.9386 13.1723 22.7212 13.6972 22.3342 14.0842ZM41.5 35.3125H29.125C28.578 35.3125 28.0534 35.0952 27.6666 34.7084C27.2798 34.3216 27.0625 33.797 27.0625 33.25C27.0625 32.703 27.2798 32.1784 27.6666 31.7916C28.0534 31.4048 28.578 31.1875 29.125 31.1875H41.5C42.047 31.1875 42.5716 31.4048 42.9584 31.7916C43.3452 32.1784 43.5625 32.703 43.5625 33.25C43.5625 33.797 43.3452 34.3216 42.9584 34.7084C42.5716 35.0952 42.047 35.3125 41.5 35.3125ZM41.5 18.8125H29.125C28.578 18.8125 28.0534 18.5952 27.6666 18.2084C27.2798 17.8216 27.0625 17.297 27.0625 16.75C27.0625 16.203 27.2798 15.6784 27.6666 15.2916C28.0534 14.9048 28.578 14.6875 29.125 14.6875H41.5C42.047 14.6875 42.5716 14.9048 42.9584 15.2916C43.3452 15.6784 43.5625 16.203 43.5625 16.75C43.5625 17.297 43.3452 17.8216 42.9584 18.2084C42.5716 18.5952 42.047 18.8125 41.5 18.8125Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ===system-info-end=== */}

      {/* <!-- ===We-Provide-start=== --> */}
      <section className="we_provide p-100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="we_provide_title">
                <h2>Launch Your, Successful Store</h2>
                <button
                  className="cmn-btn"
                  onClick={() =>
                    (window.location.href = "https://register.launchestore.com")
                  }
                >
                  <span className="cmn-btn-text1">
                    Sign Up <MdOutlineArrowOutward className="button-icon" />
                  </span>
                  <span className="cmn-btn-text2">
                    Sign Up <MdOutlineArrowOutward className="button-icon" />
                  </span>
                </button>
              </div>
            </div>
            <div className="col-12">
              <div className="we_provide_image-wrp">
                <img src={weprovideimg} alt="What_we_provide" />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="we_provide_content we_provide_content1">
                <h3>Create Your Online Shop</h3>
                <p>
                  Set up your store quickly with user-friendly tools that
                  simplify online selling.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="we_provide_content we_provide_content2">
                <h3>Choose a Store Theme</h3>
                <p>
                  Discover a variety of stylish premium themes to enhance your
                  store's look.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="we_provide_content we_provide_content3">
                <h3>Customize Your Brand Identity</h3>
                <p>
                  Personalize your store with easy design options that reflect
                  your unique brand style.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ===We-Provide-end=== --> */}

      {/* <!-- ===Build-Web-App-start=== --> */}
      <section className="build_web_app p-100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="build_web_app-title">
                <h2>Make Your Products Shine in Your Store</h2>
                <div>
                  <p>
                    Save time and money with LaunchEstore’s all-in-one platform.
                    Build your site, sell products, and engage clients to grow
                    your online business.
                  </p>
                  <button
                    className="cmn-btn"
                    onClick={() =>
                      (window.location.href =
                        "https://register.launchestore.com")
                    }
                  >
                    <span className="cmn-btn-text1">
                      Sign Up <MdOutlineArrowOutward className="button-icon" />
                    </span>
                    <span className="cmn-btn-text2">
                      Sign Up <MdOutlineArrowOutward className="button-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="build_web_app-inner">
          <div className="row">
            <div className="col-lg-6">
              <div className="build_web_app-image-wrp build-web-image-wrp">
                <img src={buildwebsiteimg} alt="bulid_website" />
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="build_web_app-content-wrp">
                <h3>Scalable Infrastructure</h3>
                <p>
                  Our infrastructure is designed to support your business growth
                  and scalability effortlessly.
                </p>
                <ul>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1066)">
                          <path
                            d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1066">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.355469)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Scalable Architecture, Easily adjust resources as your
                    business grows.
                  </li>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1071)">
                          <path
                            d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1071">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.544678)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Robust Security,Protect your data with advanced security
                    protocols.
                  </li>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1077)">
                          <path
                            d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1077">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.724609)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    High Availability,Ensure your services are always online and
                    accessible.
                  </li>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1084)">
                          <path
                            d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1084">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.916016)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Seamless Integration,Connect with various tools and
                    platforms effortlessly.
                  </li>
                </ul>
                <button
                  className="cmn-btn"
                  onClick={() =>
                    (window.location.href = "https://register.launchestore.com")
                  }
                >
                  <span className="cmn-btn-text1">
                    Sign Up <MdOutlineArrowOutward className="button-icon" />
                  </span>
                  <span className="cmn-btn-text2">
                    Sign Up <MdOutlineArrowOutward className="button-icon" />
                  </span>
                </button>

                <div className="build_web_app-content-profile d-none">
                  <p>
                    “LaunchEstore transformed my online business! Setting up my
                    store was so simple, and their customer support is always
                    there to help. Thanks to their tools, I reached new
                    customers and saw sales skyrocket. Highly recommended!”
                  </p>
                  <div className="build_web_app-profile-inner d-none">
                    <div className="build_web_app-profile-img">
                      <img src={profileimg} alt="" />
                    </div>
                    <div className="build_web_app-profile-content">
                      <h4>Priya Mehta</h4>
                      <p>Jwellery Owner</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="build_web_app-inner build-app-wrap">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="build_web_app-content-wrp">
                <h3>Create Online Business</h3>
                <p>
                  Create a unique store and access powerful tools to grow your
                  business seamlessly.
                </p>
                <ul>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1066)">
                          <path
                            d="M7.71478 6.79039C7.71478 7.75929 6.85098 8.54539 5.78632 8.54539H1.92942C0.86436 8.54539 0.000976562 7.75929 0.000976562 6.79039V3.28039C0.000976562 2.31112 0.86436 1.52539 1.92942 1.52539H5.78632C6.85098 1.52539 7.71478 2.31112 7.71478 3.28039V6.79039ZM7.71478 16.1504C7.71478 17.1193 6.85098 17.9054 5.78632 17.9054H1.92942C0.86436 17.9054 0.000976562 17.1193 0.000976562 16.1504V12.6404C0.000976562 11.6715 0.86436 10.8854 1.92942 10.8854H5.78632C6.85098 10.8854 7.71478 11.6715 7.71478 12.6404V16.1504ZM10.286 3.28039C10.286 2.31112 11.1498 1.52539 12.2145 1.52539H16.0714C17.136 1.52539 17.9998 2.31112 17.9998 3.28039V6.79039C17.9998 7.75929 17.136 8.54539 16.0714 8.54539H12.2145C11.1498 8.54539 10.286 7.75929 10.286 6.79039V3.28039ZM17.9998 16.1504C17.9998 17.1193 17.136 17.9054 16.0714 17.9054H12.2145C11.1498 17.9054 10.286 17.1193 10.286 16.1504V12.6404C10.286 11.6715 11.1498 10.8854 12.2145 10.8854H16.0714C17.136 10.8854 17.9998 11.6715 17.9998 12.6404V16.1504Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1066">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.355469)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Sell products, services, and digital downloads.
                  </li>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1071)">
                          <path
                            d="M8.17425 1.07897C8.69809 0.845747 9.30271 0.845747 9.82655 1.07897L17.5112 4.49922C17.81 4.63125 17.9998 4.91901 17.9998 5.20677C17.9998 5.55209 17.81 5.83984 17.5112 5.97526L9.82655 9.39455C9.30271 9.62812 8.69809 9.62812 8.17425 9.39455L0.490672 5.97526C0.192144 5.83984 0.000976562 5.55209 0.000976562 5.20677C0.000976562 4.91901 0.192109 4.63125 0.490672 4.49922L8.17425 1.07897ZM17.5112 8.83259C17.81 8.96456 17.9998 9.25235 17.9998 9.54013C17.9998 9.88544 17.81 10.1732 17.5112 10.3086L9.82655 13.7279C9.30271 13.9614 8.69809 13.9614 8.17425 13.7279L0.490672 10.3086C0.192144 10.1732 0.000976562 9.88544 0.000976562 9.54013C0.000976562 9.25235 0.192109 8.96456 0.490672 8.83259L2.36086 7.99974L7.70319 10.3763C8.52581 10.7453 9.47499 10.7453 10.2976 10.3763L15.641 7.99974L17.5112 8.83259ZM10.2976 14.7097L15.641 12.3331L17.5112 13.1659C17.81 13.2979 17.9998 13.5857 17.9998 13.8735C17.9998 14.2188 17.81 14.5065 17.5112 14.6419L9.82655 18.0612C9.30271 18.2948 8.69809 18.2948 8.17425 18.0612L0.490672 14.6419C0.192144 14.5065 0.000976562 14.2188 0.000976562 13.8735C0.000976562 13.5857 0.192109 13.2979 0.490672 13.1659L2.36086 12.3331L7.70319 14.7097C8.52581 15.0787 9.47499 15.0787 10.2976 14.7097Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1071">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.544678)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Receive payments instantly, no commissions.
                  </li>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1077)">
                          <path
                            d="M9.0004 19.3453C4.02962 19.3453 0.000976562 15.1775 0.000976562 10.0349C0.000976562 4.89244 4.02962 0.724609 9.0004 0.724609C13.9712 0.724609 17.9998 4.89244 17.9998 10.0349C17.9998 15.1775 13.9712 19.3453 9.0004 19.3453ZM8.15669 10.0349C8.15669 10.3259 8.29729 10.5987 8.53286 10.7296L11.9076 13.0572C12.2943 13.3554 12.8181 13.2463 13.0466 12.8462C13.3349 12.4462 13.2294 11.9043 12.8427 11.6352L9.84411 9.56945V5.08883C9.84411 4.60513 9.46794 4.21599 8.96879 4.21599C8.53286 4.21599 8.12508 4.60513 8.12508 5.08883L8.15669 10.0349Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1077">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.724609)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Effortlessly manage inventory, shipping, and taxes.
                  </li>
                  <li>
                    <span>
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_941_1084)">
                          <path
                            d="M14.7633 2.06836C16.0347 2.06836 17.0685 3.1004 17.0685 4.37378V15.9009C17.0685 17.1725 16.0347 18.2063 14.7633 18.2063H3.23691C1.96361 18.2063 0.931641 17.1725 0.931641 15.9009V4.37378C0.931641 3.1004 1.96361 2.06836 3.23691 2.06836H14.7633ZM9.74929 5.72822C9.74929 5.29955 9.3999 4.95014 8.9713 4.95014C8.54264 4.95014 8.19324 5.29955 8.19324 5.72822V6.30817C7.97352 6.3586 7.76103 6.39462 7.56287 6.51349C6.91454 6.79087 6.3022 7.31319 6.15812 8.0985C6.00684 8.93057 6.36704 9.67982 7.06943 10.1301C7.58088 10.4579 8.25805 10.6489 8.80199 10.8037C8.88119 10.8254 8.93167 10.847 9.04689 10.8722C9.47555 10.9874 9.92583 11.0775 10.2896 11.3585C10.7111 11.6466 10.5093 12.1582 10.0771 12.3022C9.72412 12.4644 9.26661 12.5184 8.65431 12.4284C8.23649 12.3635 7.81861 12.2194 7.41164 12.0825C7.32156 12.0537 7.23151 12.0213 7.14146 11.9925C6.73444 11.8556 6.29139 12.0789 6.15812 12.4859C6.02125 12.893 6.24457 13.3361 6.6516 13.4694C7.15948 13.6351 7.67093 13.8044 8.19324 13.9196V14.5464C8.19324 14.9751 8.54264 15.3245 8.9713 15.3245C9.3999 15.3245 9.74929 14.9751 9.74929 14.5464V13.9989C10.0699 13.9629 10.376 13.8909 10.657 13.7756C11.3342 13.5054 11.8925 12.9759 12.0438 12.169C12.1951 11.3332 11.8673 10.5516 11.1685 10.0725C10.6318 9.70506 9.91499 9.50334 9.3531 9.34125C9.27022 9.31962 9.18379 9.29438 9.10091 9.24035C8.69033 9.16115 8.26166 9.04586 7.9051 8.81889C7.45482 8.53074 7.78259 8.11289 8.17885 7.93996C8.62545 7.74908 9.17656 7.70583 9.65202 7.79588C9.90776 7.84629 10.1599 7.91833 10.4121 7.98682C10.4661 8.00483 10.5237 8.01923 10.5778 8.03362C10.992 8.14891 11.4206 7.90755 11.5359 7.49333C11.6511 7.07905 11.4062 6.65038 10.992 6.50269C10.9272 6.5171 10.8587 6.49548 10.7939 6.47747C10.4481 6.38021 10.0987 6.28295 9.74929 6.23973V5.72822Z"
                            fill="#040404"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_941_1084">
                            <rect
                              width="17.9988"
                              height="18.72"
                              fill="white"
                              transform="translate(0.000976562 0.916016)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Enjoy a smooth, branded checkout experience.
                  </li>
                </ul>
                <button
                  className="cmn-btn"
                  onClick={() =>
                    (window.location.href = "https://register.launchestore.com")
                  }
                >
                  <span className="cmn-btn-text1">
                    Sign Up <MdOutlineArrowOutward className="button-icon" />
                  </span>
                  <span className="cmn-btn-text2">
                    Sign Up <MdOutlineArrowOutward className="button-icon" />
                  </span>
                </button>

                <div className="build_web_app-content-profile d-none">
                  <p>
                    “As a small business owner, I needed an affordable
                    e-commerce solution that didn’t compromise quality.
                    LaunchEstore delivered with easy-to-use features and
                    seamless payment integration. My business growth has been
                    incredible since launching!”
                  </p>
                  <div className="build_web_app-profile-inner d-none">
                    <div className="build_web_app-profile-img">
                      <img src={profileimg} alt="" />
                    </div>
                    <div className="build_web_app-profile-content">
                      <h4>Rakesh Patel</h4>
                      <p>Small Business Owner</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 ">
              <div className="build_web_app-image-wrp build-app-image-wrp">
                <img src={buildappimg} alt="bulid_website" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ===Build-Web-App-start=== --> */}

      {/* ===Reach-Customer-start=== */}
      <section className="reach_customer p-100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="build_web_app-title">
                {/* <h2>Reach Customers Where They are—Seamlessly</h2> */}
                <h2>
                  The one commerce platform which has powerful features to run
                  your business online and offline seamlessly.
                </h2>
              </div>
            </div>
            <div className="col-12 ">
              <div className="row" style={{ rowGap: "30px" }}>
                <div className="col-lg-6">
                  <div className="reach_customer_wrp">
                    <div className="reach_customer_wrp_img">
                      <img src={reachCustomeMain} alt={reachCustomeMain} />
                      <span className="reach_customer_img_left">
                        <svg
                          width="30"
                          height="20"
                          viewBox="0 0 30 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M28.2557 17.6271H27.309V2.70442L28.4533 2.45827C28.5775 2.43498 28.6958 2.38706 28.8012 2.31733C28.9066 2.24761 28.9969 2.15749 29.067 2.05229C29.137 1.94709 29.1852 1.82894 29.2088 1.7048C29.2325 1.58067 29.231 1.45305 29.2045 1.32949C29.1781 1.20593 29.1271 1.08891 29.0547 0.985346C28.9823 0.881778 28.8899 0.793753 28.783 0.72646C28.676 0.659166 28.5567 0.613967 28.432 0.593524C28.3073 0.573082 28.1797 0.577812 28.0569 0.607434L1.54869 6.28776C1.32032 6.33704 1.11824 6.46902 0.981314 6.65831C0.844388 6.8476 0.782287 7.08084 0.806958 7.31316C0.831629 7.54547 0.941329 7.76047 1.11496 7.91678C1.28859 8.07309 1.51388 8.15968 1.7475 8.1599C1.81473 8.15978 1.88176 8.15264 1.9475 8.1386L2.69422 7.97884V17.6271H1.7475C1.49642 17.6271 1.25561 17.7269 1.07807 17.9044C0.900525 18.0819 0.800781 18.3228 0.800781 18.5738C0.800781 18.8249 0.900525 19.0657 1.07807 19.2433C1.25561 19.4208 1.49642 19.5206 1.7475 19.5206H28.2557C28.5068 19.5206 28.7476 19.4208 28.9251 19.2433C29.1027 19.0657 29.2024 18.8249 29.2024 18.5738C29.2024 18.3228 29.1027 18.0819 28.9251 17.9044C28.7476 17.7269 28.5068 17.6271 28.2557 17.6271ZM4.58767 7.5682L25.4155 3.11033V17.6271H22.5754V11.0001C22.5754 10.749 22.4756 10.5082 22.2981 10.3306C22.1205 10.1531 21.8797 10.0533 21.6287 10.0533H8.37455C8.12347 10.0533 7.88266 10.1531 7.70512 10.3306C7.52757 10.5082 7.42783 10.749 7.42783 11.0001V17.6271H4.58767V7.5682ZM20.6819 13.8402H9.32127V11.9468H20.6819V13.8402ZM9.32127 15.7337H20.6819V17.6271H9.32127V15.7337Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      <span className="reach_customer_img_top">
                        <BiPlus /> Create New
                      </span>
                      <span className="reach_customer_img_bottom">Active</span>
                    </div>
                    <div className="reach_customer_wrp_content">
                      <h3>Warehouse</h3>
                      <h5>
                        Streamline storage, tracking, and fulfillment with
                        intelligent warehouse management.
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="reach_customer_wrp reach_customer_wrp_2">
                    <div className="reach_customer_wrp_img">
                      <img src={reachCustomeMain2} alt={reachCustomeMain2} />
                      <span className="reach_customer_img_left">
                        <svg
                          width="26"
                          height="22"
                          viewBox="0 0 26 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M25.3062 1.5329V6.26651C25.3062 6.5176 25.2064 6.7584 25.0289 6.93594C24.8513 7.11349 24.6105 7.21323 24.3594 7.21323C24.1084 7.21323 23.8676 7.11349 23.69 6.93594C23.5125 6.7584 23.4127 6.5176 23.4127 6.26651V2.47962H19.6258C19.3747 2.47962 19.1339 2.37988 18.9564 2.20234C18.7789 2.02479 18.6791 1.78399 18.6791 1.5329C18.6791 1.28182 18.7789 1.04101 18.9564 0.86347C19.1339 0.685925 19.3747 0.586182 19.6258 0.586182H24.3594C24.6105 0.586182 24.8513 0.685925 25.0289 0.86347C25.2064 1.04101 25.3062 1.28182 25.3062 1.5329ZM6.37173 19.5206H2.58485V15.7337C2.58485 15.4826 2.48511 15.2418 2.30756 15.0643C2.13002 14.8867 1.88921 14.787 1.63813 14.787C1.38704 14.787 1.14624 14.8867 0.968694 15.0643C0.79115 15.2418 0.691406 15.4826 0.691406 15.7337V20.4673C0.691406 20.7184 0.79115 20.9592 0.968694 21.1368C1.14624 21.3143 1.38704 21.4141 1.63813 21.4141H6.37173C6.62282 21.4141 6.86362 21.3143 7.04117 21.1368C7.21871 20.9592 7.31846 20.7184 7.31846 20.4673C7.31846 20.2162 7.21871 19.9754 7.04117 19.7979C6.86362 19.6204 6.62282 19.5206 6.37173 19.5206ZM24.3594 14.787C24.1084 14.787 23.8676 14.8867 23.69 15.0643C23.5125 15.2418 23.4127 15.4826 23.4127 15.7337V19.5206H19.6258C19.3747 19.5206 19.1339 19.6204 18.9564 19.7979C18.7789 19.9754 18.6791 20.2162 18.6791 20.4673C18.6791 20.7184 18.7789 20.9592 18.9564 21.1368C19.1339 21.3143 19.3747 21.4141 19.6258 21.4141H24.3594C24.6105 21.4141 24.8513 21.3143 25.0289 21.1368C25.2064 20.9592 25.3062 20.7184 25.3062 20.4673V15.7337C25.3062 15.4826 25.2064 15.2418 25.0289 15.0643C24.8513 14.8867 24.6105 14.787 24.3594 14.787ZM1.63813 7.21323C1.88921 7.21323 2.13002 7.11349 2.30756 6.93594C2.48511 6.7584 2.58485 6.5176 2.58485 6.26651V2.47962H6.37173C6.62282 2.47962 6.86362 2.37988 7.04117 2.20234C7.21871 2.02479 7.31846 1.78399 7.31846 1.5329C7.31846 1.28182 7.21871 1.04101 7.04117 0.86347C6.86362 0.685925 6.62282 0.586182 6.37173 0.586182H1.63813C1.38704 0.586182 1.14624 0.685925 0.968694 0.86347C0.79115 1.04101 0.691406 1.28182 0.691406 1.5329V6.26651C0.691406 6.5176 0.79115 6.7584 0.968694 6.93594C1.14624 7.11349 1.38704 7.21323 1.63813 7.21323ZM7.31846 5.31979C7.06737 5.31979 6.82657 5.41953 6.64902 5.59708C6.47148 5.77462 6.37173 6.01542 6.37173 6.26651V15.7337C6.37173 15.9848 6.47148 16.2256 6.64902 16.4032C6.82657 16.5807 7.06737 16.6804 7.31846 16.6804C7.56954 16.6804 7.81034 16.5807 7.98789 16.4032C8.16543 16.2256 8.26518 15.9848 8.26518 15.7337V6.26651C8.26518 6.01542 8.16543 5.77462 7.98789 5.59708C7.81034 5.41953 7.56954 5.31979 7.31846 5.31979ZM19.6258 15.7337V6.26651C19.6258 6.01542 19.5261 5.77462 19.3485 5.59708C19.171 5.41953 18.9302 5.31979 18.6791 5.31979C18.428 5.31979 18.1872 5.41953 18.0097 5.59708C17.8321 5.77462 17.7324 6.01542 17.7324 6.26651V15.7337C17.7324 15.9848 17.8321 16.2256 18.0097 16.4032C18.1872 16.5807 18.428 16.6804 18.6791 16.6804C18.9302 16.6804 19.171 16.5807 19.3485 16.4032C19.5261 16.2256 19.6258 15.9848 19.6258 15.7337ZM14.8922 5.31979C14.6411 5.31979 14.4003 5.41953 14.2228 5.59708C14.0452 5.77462 13.9455 6.01542 13.9455 6.26651V15.7337C13.9455 15.9848 14.0452 16.2256 14.2228 16.4032C14.4003 16.5807 14.6411 16.6804 14.8922 16.6804C15.1433 16.6804 15.3841 16.5807 15.5617 16.4032C15.7392 16.2256 15.8389 15.9848 15.8389 15.7337V6.26651C15.8389 6.01542 15.7392 5.77462 15.5617 5.59708C15.3841 5.41953 15.1433 5.31979 14.8922 5.31979ZM11.1053 5.31979C10.8543 5.31979 10.6135 5.41953 10.4359 5.59708C10.2584 5.77462 10.1586 6.01542 10.1586 6.26651V15.7337C10.1586 15.9848 10.2584 16.2256 10.4359 16.4032C10.6135 16.5807 10.8543 16.6804 11.1053 16.6804C11.3564 16.6804 11.5972 16.5807 11.7748 16.4032C11.9523 16.2256 12.0521 15.9848 12.0521 15.7337V6.26651C12.0521 6.01542 11.9523 5.77462 11.7748 5.59708C11.5972 5.41953 11.3564 5.31979 11.1053 5.31979Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      <span className="reach_customer_img_top">
                        Generate PDF
                      </span>
                      <span className="reach_customer_img_bottom">Print</span>
                    </div>
                    <div className="reach_customer_wrp_content">
                      <h3>Generate Barcode</h3>
                      <h5>
                        Quickly generate barcodes to simplify product tracking,
                        inventory management, and order accuracy.
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="reach_customer_wrp reach_customer_wrp_3">
                    <div className="reach_customer_wrp_img">
                      <img src={reachCustomeMain3} alt={reachCustomeMain3} />
                      <span className="reach_customer_img_left">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M29.6471 16.9465L17.8947 5.19419C17.7195 5.0176 17.511 4.87759 17.2812 4.78231C17.0515 4.68703 16.805 4.63838 16.5563 4.63917H5.58736C5.33627 4.63917 5.09547 4.73891 4.91792 4.91646C4.74038 5.094 4.64063 5.33481 4.64063 5.58589V16.5548C4.63984 16.8036 4.6885 17.05 4.78378 17.2798C4.87906 17.5095 5.01906 17.7181 5.19565 17.8933L16.948 29.6456C17.1238 29.8215 17.3326 29.961 17.5623 30.0562C17.7921 30.1514 18.0383 30.2004 18.287 30.2004C18.5357 30.2004 18.782 30.1514 19.0117 30.0562C19.2415 29.961 19.4502 29.8215 19.6261 29.6456L29.6471 19.6246C29.823 19.4488 29.9625 19.24 30.0577 19.0103C30.1528 18.7805 30.2018 18.5343 30.2018 18.2856C30.2018 18.0369 30.1528 17.7906 30.0577 17.5609C29.9625 17.3311 29.823 17.1224 29.6471 16.9465ZM18.2864 28.3072L6.53408 16.5548V6.53261H16.5563L28.3087 18.285L18.2864 28.3072ZM12.2144 10.7929C12.2144 11.0737 12.1311 11.3483 11.9751 11.5818C11.819 11.8153 11.5973 11.9974 11.3378 12.1048C11.0783 12.2123 10.7927 12.2404 10.5173 12.1857C10.2418 12.1309 9.98878 11.9956 9.79017 11.797C9.59157 11.5984 9.45632 11.3454 9.40153 11.0699C9.34673 10.7944 9.37486 10.5089 9.48234 10.2494C9.58982 9.98993 9.77184 9.76814 10.0054 9.6121C10.2389 9.45606 10.5135 9.37278 10.7943 9.37278C11.171 9.37278 11.5322 9.52239 11.7985 9.78871C12.0648 10.055 12.2144 10.4162 12.2144 10.7929Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      <span className="reach_customer_img_top">
                        Retrieve Sale
                      </span>
                      <span className="reach_customer_img_bottom">
                        Open/close
                      </span>
                    </div>
                    <div className="reach_customer_wrp_content">
                      <h3>Point of Sale</h3>
                      <h5>
                        Seamlessly manage in-store and online sales with a
                        unified, real-time Point of Sale system.
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="reach_customer_wrp reach_customer_wrp_4">
                    <div className="reach_customer_wrp_img">
                      <img src={reachCustomeMain4} alt={reachCustomeMain4} />
                      <span className="reach_customer_img_left">
                        <svg
                          width="26"
                          height="23"
                          viewBox="0 0 26 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24.3594 20.5203H23.4127V1.58588C23.4127 1.3348 23.313 1.09399 23.1354 0.916449C22.9579 0.738904 22.7171 0.63916 22.466 0.63916H15.8389C15.5879 0.63916 15.3471 0.738904 15.1695 0.916449C14.992 1.09399 14.8922 1.3348 14.8922 1.58588V6.31949H9.2119C8.96081 6.31949 8.72001 6.41923 8.54247 6.59678C8.36492 6.77432 8.26518 7.01512 8.26518 7.26621V11.9998H3.53157C3.28048 11.9998 3.03968 12.0996 2.86214 12.2771C2.68459 12.4546 2.58485 12.6955 2.58485 12.9465V20.5203H1.63813C1.38704 20.5203 1.14624 20.62 0.968694 20.7976C0.79115 20.9751 0.691406 21.2159 0.691406 21.467C0.691406 21.7181 0.79115 21.9589 0.968694 22.1365C1.14624 22.314 1.38704 22.4137 1.63813 22.4137H24.3594C24.6105 22.4137 24.8513 22.314 25.0289 22.1365C25.2064 21.9589 25.3062 21.7181 25.3062 21.467C25.3062 21.2159 25.2064 20.9751 25.0289 20.7976C24.8513 20.62 24.6105 20.5203 24.3594 20.5203ZM16.7857 2.5326H21.5193V20.5203H16.7857V2.5326ZM10.1586 8.21293H14.8922V20.5203H10.1586V8.21293ZM4.47829 13.8933H8.26518V20.5203H4.47829V13.8933Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      <span className="reach_customer_img_top">
                        Print Report
                      </span>
                      <span className="reach_customer_img_bottom">
                        Export Excel
                      </span>
                    </div>
                    <div className="reach_customer_wrp_content">
                      <h3>Reports</h3>
                      <h5>
                        Gain actionable insights with real-time reports on
                        sales, inventory, and customer behavior.
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ===Reach-Customer-end=== */}

      {/* <!-- ===WebSite-Templates-start=== --> */}
      <section className="website-templates p-100 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="website-templates-title">
                <h2>Choose a template designed for business growth</h2>
                <p>
                  Choose from a range of professional templates designed to help
                  your business grow. Customize easily and launch your store
                  quickly with themes built to boost engagement and drive sales.
                </p>
                <button
                  className="cmn-btn"
                  onClick={() => {
                    navigate("/portfolio");
                  }}
                >
                  <span className="cmn-btn-text1">
                    Browse Portfolio{" "}
                    <MdOutlineArrowOutward className="button-icon" />
                  </span>
                  <span className="cmn-btn-text2">
                    Browse Portfolio{" "}
                    <MdOutlineArrowOutward className="button-icon" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="website-templates-images-wrp">
              <div className="website-templates-images-1">
                <img src={websitetempletsimg1} alt="" />
              </div>
              <div className="website-templates-images-2">
                <img src={websitetempletsimg2} alt="" />
              </div>
              <div className="marquee">
                <div className="marquee__row">
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                </div>
                <div aria-hidden="true" className="marquee__row">
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                  <div className="marquee__item">
                    <p className="marquee__text">Book A Free Demo</p>
                  </div>
                  <span className="marquee__separator">&#9679;</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ===WebSite-Templates-end=== --> */}

      {/* ===intelligent-apps-start=== */}
      <section className="intelligent_apps p-100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="build_web_app-title">
                <h2>Turn your data into intelligent apps</h2>
                <div>
                  <button className="cmn-btn">
                    <span className="cmn-btn-text1">
                      Get Started{" "}
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        className="button-icon"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"></path>
                      </svg>
                    </span>
                    <span className="cmn-btn-text2">
                      Get Started{" "}
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        className="button-icon"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"></path>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="intelligent_apps_wrp">
            <div className="intelligent_apps_or">OR</div>
            <div className="row">
              <div className="col-lg-6">
                <div className="intelligent_apps_card intelligent_apps_card_left">
                  <div className="intelligent_apps_card_img">
                    <img src={intelligentappsimg1} alt={intelligentappsimg1} />
                  </div>
                  <div className="intelligent_apps_card_content">
                    <h3>In-person point of sale.</h3>
                    <p>
                      Sell face to face and keep offline and online sales in
                      sync with
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="intelligent_apps_card intelligent_apps_card_right">
                  <div className="intelligent_apps_card_img">
                    <img src={intelligentappsimg2} alt={intelligentappsimg1} />
                  </div>
                  <div className="intelligent_apps_card_content">
                    <h3>Run your store from anywhere.</h3>
                    <p>
                      Do it all right from your phone with the full-featured
                      LaunchEStore Business mobile app.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ===intelligent-apps-end=== */}

      {/* <!-- ===growth-start=== --> */}
      <section className="website_growth p-100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="build_web_app-title">
                <h2>Launchestore versatile solution & Features</h2>
                <div>
                  <button
                    className="cmn-btn"
                    onClick={() => {
                      navigate("/features");
                    }}
                  >
                    <span className="cmn-btn-text1">
                      Browse Features{" "}
                      <MdOutlineArrowOutward className="button-icon" />
                    </span>
                    <span className="cmn-btn-text2">
                      Browse Features{" "}
                      <MdOutlineArrowOutward className="button-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Zero IT Cost</h3>
                  <p>
                    Join thousands of businesses trusting our eCommerce
                    platform.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Easy Store Management</h3>
                  <p>
                    Quickly manage products & speed up tasks with your
                    dashboard.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Integrated Logistics</h3>
                  <p>
                    Increase sales with our app no restrictions, friction, or
                    limits.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Integrated Payment Gateway</h3>
                  <p>
                    Quick, secure payments with our integrated payment system.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>SEO Friendly URL </h3>
                  <p>
                    Boost traffic with SEO-friendly URLs and editable robots.txt
                    files.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Multi Branches Platform</h3>
                  <p>
                    Manage multiple brands & regions easily from a single
                    account.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Launch Mobile Applications</h3>
                  <p>
                    Launch your new store and impress customers with
                    Launchestore.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
              <div className="website_growth_card">
                <div className="website_growth_card_img">
                  <svg
                    viewBox="0 0 42 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.3125 33.375C41.3125 33.7894 41.1479 34.1868 40.8549 34.4799C40.5618 34.7729 40.1644 34.9375 39.75 34.9375H2.25C1.8356 34.9375 1.43817 34.7729 1.14515 34.4799C0.85212 34.1868 0.6875 33.7894 0.6875 33.375V2.125C0.6875 1.7106 0.85212 1.31317 1.14515 1.02015C1.43817 0.72712 1.8356 0.5625 2.25 0.5625C2.6644 0.5625 3.06183 0.72712 3.35485 1.02015C3.64788 1.31317 3.8125 1.7106 3.8125 2.125V23.3535L13.6445 13.5195C13.7896 13.3743 13.962 13.259 14.1517 13.1804C14.3413 13.1017 14.5447 13.0613 14.75 13.0613C14.9553 13.0613 15.1587 13.1017 15.3483 13.1804C15.538 13.259 15.7104 13.3743 15.8555 13.5195L21 18.666L31.291 8.375H27.25C26.8356 8.375 26.4382 8.21038 26.1451 7.91735C25.8521 7.62433 25.6875 7.2269 25.6875 6.8125C25.6875 6.3981 25.8521 6.00067 26.1451 5.70765C26.4382 5.41462 26.8356 5.25 27.25 5.25H35.0625C35.4769 5.25 35.8743 5.41462 36.1674 5.70765C36.4604 6.00067 36.625 6.3981 36.625 6.8125V14.625C36.625 15.0394 36.4604 15.4368 36.1674 15.7299C35.8743 16.0229 35.4769 16.1875 35.0625 16.1875C34.6481 16.1875 34.2507 16.0229 33.9576 15.7299C33.6646 15.4368 33.5 15.0394 33.5 14.625V10.584L22.1055 21.9805C21.9604 22.1257 21.788 22.241 21.5983 22.3196C21.4087 22.3983 21.2053 22.4387 21 22.4387C20.7947 22.4387 20.5913 22.3983 20.4017 22.3196C20.212 22.241 20.0396 22.1257 19.8945 21.9805L14.75 16.834L3.8125 27.7715V31.8125H39.75C40.1644 31.8125 40.5618 31.9771 40.8549 32.2701C41.1479 32.5632 41.3125 32.9606 41.3125 33.375Z"
                      fill="#977521"
                    />
                  </svg>
                </div>
                <div className="website_growth_card_content">
                  <h3>Your Own Brand Websites</h3>
                  <p>
                    Easily build a website with Launchestore to showcase your
                    brand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ===growth-end=== --> */}

      {/* <!-- ===Our-Projects-start=== --> */}
      <section className="our_proejcts p-100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="build_web_app-title our_proejcts_title">
                <h2>Explore Our Creative Portfolio</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 mb-md-5 mb-4">
              <Link
                to="/zumkha-detail"
                className="our_proejcts_card our_proejcts_card-1"
              >
                <div className="our_proejcts_card_img">
                  <img src={jewellerystoreimg} alt="our-proejcts" />
                </div>
                <div className="our_proejcts_card_content">
                  <h6>Website</h6>
                  <h4>
                    Zumkha offers timeless jewelry crafted to enhance elegance
                    and cherished moments.
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 mb-md-5 mb-4">
              <Link
                to="/kishori-detail"
                className="our_proejcts_card our_proejcts_card-2"
              >
                <div className="our_proejcts_card_img">
                  <img src={kishoricreationimg} alt="our-proejcts" />
                </div>
                <div className="our_proejcts_card_content">
                  <h6>Website</h6>
                  <h4>
                    Kishori Creation offers elegant, sustainable fashion
                    blending tradition and modern style.
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 mb-md-5 mb-4">
              <Link
                to="/Unibest-Detail"
                className="our_proejcts_card our_proejcts_card-3"
              >
                <div className="our_proejcts_card_img">
                  <img src={unibestimg} alt="our-proejcts" />
                </div>
                <div className="our_proejcts_card_content">
                  <h6>Website</h6>
                  <h4>
                    Unibest crafts quality uniforms ensuring comfort, safety,
                    and sustainable solutions.
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 mb-md-5 mb-4">
              <Link
                to="/dpdecor-detail"
                className="our_proejcts_card our_proejcts_card-4"
              >
                <div className="our_proejcts_card_img">
                  <img src={interiordesigningimg} alt="our-proejcts" />
                </div>
                <div className="our_proejcts_card_content">
                  <h6>Website</h6>
                  <h4>
                    DP Decor creates bespoke interior designs, blending
                    innovation with personalized client vision.
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 mb-md-5 mb-4">
              <Link
                to="/YashIndustries_Detail"
                className="our_proejcts_card our_proejcts_card-5"
              >
                <div className="our_proejcts_card_img">
                  <img src={yashindustriesimg} alt="our-proejcts" />
                </div>
                <div className="our_proejcts_card_content">
                  <h6>Website</h6>
                  <h4>
                    Yash Industries manufactures high-quality cooking
                    appliances, offering durable, reliable solutions globally.
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6 mb-md-5 mb-4">
              <Link
                to="/laxmiraj-detail"
                className="our_proejcts_card our_proejcts_card-6"
              >
                <div className="our_proejcts_card_img">
                  <img src={laxmirajdryfruitsimg} alt="our-proejcts" />
                </div>
                <div className="our_proejcts_card_content">
                  <h6>Website</h6>
                  <h4>
                    Laxmiraj Dry Fruits offers premium dry fruits, nuts, and
                    spices across India.
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-12 text-center">
              <button
                className="cmn-btn"
                onClick={() => {
                  navigate("/portfolio");
                }}
              >
                <span className="cmn-btn-text1">
                  View Portfolio{" "}
                  <MdOutlineArrowOutward className="button-icon" />
                </span>
                <span className="cmn-btn-text2">
                  View Portfolio{" "}
                  <MdOutlineArrowOutward className="button-icon" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ===Our-Projects-end=== --> */}

      <WebsiteStep classes={"websitestep_sub"} />
      {/* <SuccessBanner/>
      <Blog/> */}
      <LocationSlider />
    </>
  );
};

export default Home;
